export default {
  translations: {
    'Try it out': 'Ausprobieren',
    'Preview not available': 'Vorschau nicht verfügbar',
    'New Board': 'Neue Tafel',
    'Import from .zip': 'Aus .zip importieren',
    'Importing...': 'Importieren...',
    'Failed to import board.': 'Tafel konnte nicht importiert werden.',
    'Create board on the tablet?': 'Tafel auf dem Tablet erstellen?',
    'Import board to the tablet?': 'Tafel auf das Tablet importieren?',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      'Diese Tafel wird im Tablet-Backup dieses Benutzers erstellt, nicht in Ihren Portal-Tafeln. Sie wird bei der nächsten Synchronisierung an das Tablet gesendet.',
    'Board title': 'Titel der Tafel',
    'Enter a title for the board': 'Gib einen Titel für die Tafel ein',
    'Card language': 'Kartensprache',
    'Creating...': 'Wird erstellt...',
    'Failed to create board.': 'Tafel konnte nicht erstellt werden.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      'Wähle ein Bild aus der Bank, erstelle eines mit KI oder lade dein eigenes hoch.',
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'Wird für die Symbolbank und die Sprachausgabe (Text-to-Speech) dieser Tafel verwendet.',
    'How do you want to start?': 'Wie möchtest du beginnen?',
    'Blank board': 'Leere Tafel',
    'Start with tutorial': 'Mit Tutorial beginnen',
    'Create a board from scratch': 'Erstelle eine Tafel von Grund auf',
    'Learn the studio with a ready-made board':
      'Lerne das Studio mit einer fertigen Tafel',
    'Is this your first time creating boards?':
      'Erstellst du zum ersten Mal Tafeln?',
    "Don't show this again": 'Nicht erneut anzeigen',
    'Choose a title for your board': 'Wähle einen Titel für deine Tafel',
    'Preview board': 'Vorschau der Tafel',
    'Displayed text': 'Angezeigter Text',
    'Back and edit': 'Zurück zum Bearbeiten',
    SMALL: 'Klein',
    MEDIUM: 'Mittel',
    LARGE: 'Groß',
    login: {
      welcome: 'Willkommen bei Livox!',
      error:
        'Anmeldung mit den angegebenen Daten nicht möglich. E-Mail und/oder Passwort falsch.',
      inactive_customer:
        'Ihr Konto wurde deaktiviert. Wenden Sie sich für Unterstützung an den Support.',
    },
    payment: {
      purchaseFor: 'Kauf für',
      supportEmail: 'Kontakt-E-Mail',
    },
    pm: {
      cards: 'Karten',
      manageYourPayment:
        'Verwalten Sie Ihre Zahlungsinformationen. Um die Details Ihres monatlichen Abonnements zu sehen, gehen Sie zu Abonnements.',
      defaultPayment: 'Standardzahlung',
      setAsDefault: 'Als Standard festlegen',
      addCard: 'Karte hinzufügen',
      addBoleto: 'Boleto hinzufügen',
      creditCard: 'Kreditkarte',
      boleto: 'Boleto',
      add: 'Hinzufügen',
      boletos: 'Boletos',
    },
    paymentRegister: {
      title: 'Registrieren Sie sich, um Livox zu kaufen',
      orLoginWithAccount: 'Haben Sie bereits ein Konto?',
      loginToComplete: 'Melden Sie sich an, um Ihren Kauf abzuschließen',
      orRegisterNew: 'Oder registrieren Sie sich für ein neues Konto',
      holderAlreadyRegistered:
        'Ein Inhaber ist bereits mit dieser E-Mail registriert. Bitte melden Sie sich im Portal an.',
      holderAlreadyRegisteredTitle: 'Inhaber bereits registriert',
      holderAlreadyRegisteredMessage:
        'Ein Inhaber ist bereits mit dieser E-Mail registriert. Bitte melden Sie sich im Portal an, um auf Ihr Konto zuzugreifen.',
      holderAlreadyRegisteredMessageWithEmail:
        'Ein Inhaber ist bereits mit dieser E-Mail registriert. Die E-Mail {{email}} wurde bereits als Inhaber erstellt. Bitte melden Sie sich im Portal an, um auf Ihr Konto zuzugreifen.',
      goToLogin: 'Zum Login',
    },
    Role: 'Rolle',
    Often: 'Oft',
    Sometimes: 'Manchmal',
    Never: 'Nie',
    Date: 'Datum',
    CGQ: 'CGQ',
    VIQ: 'VIS',
    AUQ: 'AUD',
    OLQ: 'CLO',
    BHQ: 'CMP',
    Overall: 'Insgesamt',
    Actions: 'Aktionen',
    'Holder Info': 'Inhaberinformationen',
    Loading: 'Laden',
    Profile: 'Profil',
    Comments: 'Kommentare',
    'View Branch': 'Zweig anzeigen',
    'Add License to Branch': 'Lizenz zum Zweig hinzufügen',
    'Create Board': 'Board erstellen',
    'Review Publication': 'Veröffentlichung überprüfen',
    Creator: 'Ersteller',
    'Board History': 'Board-Verlauf',
    'Change Customers to Support Area': 'Kunden zur Support-Bereich ändern',
    'Change Users to Support Area': 'Benutzer zur Support-Bereich ändern',
    'Change Licenses to Branch': 'Lizenzen zum Zweig ändern',
    'Tablet code': 'Tablet-Code',
    Back: 'Zurück',
    'Livox Store': 'Livox Store',
    Communication: 'Kommunikation',
    Leisure: 'Freizeit',
    Feelings: 'Gefühle',
    Hospital: 'Krankenhaus',
    Social: 'Sozial',
    'Daily Life': 'Alltag',
    Foods: 'Lebensmittel',
    School: 'Schule',
    Education: 'Bildung',
    Literacy: 'Alphabetisierung',
    Grammar: 'Grammatik',
    Geography: 'Geografie',
    Science: 'Wissenschaft',
    History: 'Geschichte',
    Math: 'Mathematik',
    Biology: 'Biologie',
    Fun: 'Spaß',
    Stories: 'Geschichten',
    Games: 'Spiele',
    Game: 'Spiel',
    Memory: 'Gedächtnis',
    'Questions and Answers': 'Fragen und Antworten',
    'Popular Items': 'Beliebte Artikel',
    'See more': 'Mehr sehen',
    Code: 'Code',
    'Last Modified': 'Zuletzt geändert',
    'Upload from .zip': 'Aus .zip hochladen',
    'My Boards': 'Meine Boards',
    'My Portal Boards': 'Meine Portal-Boards',
    'Welcome {{name}}, you have {{count}} licenses':
      'Willkommen {{name}}, Sie haben {{count}} Lizenzen',
    'Publish one of your boards to share it with the Livox community.':
      'Veröffentlichen Sie eines Ihrer Boards, um es mit der Livox-Community zu teilen.',
    'Welcome {{name}}, you have {{count}} users':
      'Willkommen {{name}}, Sie haben {{count}} Benutzer',
    'A-Z': 'A-Z',
    Size: 'Größe',
    Studio: 'Studio',
    Favorites: 'Favoriten',
    Keyboard: 'Tastatur',
    Import: 'Importieren',
    Assign: 'Zuweisen',
    'Cover Art': 'Coverbild',
    Title: 'Titel',
    Description: 'Beschreibung',
    Categories: 'Kategorien',
    Submitter: 'Einreicher',
    'Published at': 'Veröffentlicht am',
    View: 'Ansehen',
    'Pending Approval': 'Ausstehende Genehmigung',
    'Holders Search': 'Inhaber Suche',
    'Filter Status': 'Status filtern',
    'Audit Licenses': 'Lizenzen prüfen',
    'No Device': 'Kein Gerät',
    'Livox Version': 'Livox-Version',
    'Android Version': 'Android-Version',
    'Last Validation At': 'Letzte Validierung am',
    Manage: 'Verwalten',
    Store: 'Speichern',
    Books: 'Bücher',
    'Sign up': 'Registrieren',
    Talk: 'Sprechen',
    Learn: 'Lernen',
    Admin: 'Admin',
    'Store Admin': 'Shop-Admin',
    'Discover new boards, games and stories':
      'Entdecke neue Tafeln, Spiele und Geschichten',
    'Search in store': 'Im Shop suchen',
    'Search boards, games, stories...': 'Tafeln, Spiele, Geschichten suchen...',
    'Recommended content': 'Empfohlene Inhalte',
    'Featured boards': 'Ausgewählte Tafeln',
    'New content': 'Neue Inhalte',
    'Featured creators': 'Ausgewählte Ersteller',
    'Sort by': 'Sortieren nach',
    Downloads: 'Downloads',
    'Livox Community': 'Livox Community',
    'Total downloads': 'Downloads insgesamt',
    'Community content': 'Community-Inhalte',
    Follow: 'Folgen',
    Following: 'Gefolgt',
    'View content': 'Inhalt ansehen',
    Community: 'Community',
    Logout: 'Abmelden',
    'No description': 'Keine Beschreibung',
    'No Title': 'Kein Titel',
    New: 'Neu',
    'My content': 'Meine Inhalte',
    'Unable to load your content': 'Deine Inhalte konnten nicht geladen werden',
    'Import board': 'Tafel importieren',
    'Created by': 'Erstellt von',
    'Board tags': 'Tafel-Tags',
    'No tags': 'Keine Tags',
    'Report content': 'Inhalt melden',
    'Report reason': 'Meldegrund',
    Report: 'Melden',
    'Report sent': 'Meldung gesendet',
    'Failed to send report': 'Meldung konnte nicht gesendet werden',
    'Offensive content': 'Beleidigender Inhalt',
    'Inappropriate language': 'Unangemessene Sprache',
    'Sexual or inappropriate content': 'Sexueller oder unangemessener Inhalt',
    Violence: 'Gewalt',
    'Hate speech': 'Hassrede',
    'Spam or advertising': 'Spam oder Werbung',
    'Copyright infringement': 'Urheberrechtsverletzung',
    'Duplicate content': 'Doppelter Inhalt',
    'Off-topic content': 'Themenfremder Inhalt',
    'Exposed personal data': 'Offengelegte personenbezogene Daten',
    'Content deleted': 'Inhalt gelöscht',
    'Failed to delete content': 'Inhalt konnte nicht gelöscht werden',
    'Sending...': 'Wird gesendet...',
    'New Releases': 'Neuheiten',
    'Top Rated': 'Bestbewertet',
    'See all': 'Alle ansehen',
    'Browse by category': 'Nach Kategorie durchsuchen',
    'No content found': 'Keine Inhalte gefunden',
    'Try adjusting your filters': 'Passe deine Filter an',
    'Go to slide': 'Zur Folie',
    'Back to Store': 'Zurück zum Shop',
    'Loading board...': 'Tafel wird geladen...',
    'No description provided': 'Keine Beschreibung',
    stars: 'Sterne',
    votes: 'Stimmen',
    Rate: 'Bewerten',
    'Be the first to rate': 'Sei der Erste, der bewertet',
    'In progress': 'In Bearbeitung',
    'Tablet preview': 'Tablet-Vorschau',
    'Tablet preview coming soon': 'Tablet-Vorschau bald verfügbar',
    Republish: 'Erneut veröffentlichen',
    Filters: 'Filter',
    Clear: 'Löschen',
    Speak: 'Sprechen',
    Previous: 'Vorheriges',
    'Previous page': 'Vorherige Seite',
    'Next page': 'Nächste Seite',
    'Remove last': 'Letztes entfernen',
    Fullscreen: 'Vollbild',
    'Exit fullscreen': 'Vollbild beenden',
    'Go to Portal': 'Zum Portal',
    'Sign in': 'Anmelden',
    'Sign out': 'Abmelden',
    'Open menu': 'Menü öffnen',
    'Close menu': 'Menü schließen',
    Menu: 'Menü',
    'Publication not available': 'Diese Veröffentlichung ist nicht verfügbar',
    'All languages': 'Alle Sprachen',
    'Switch to dark mode': 'Zum dunklen Modus wechseln',
    'Switch to light mode': 'Zum hellen Modus wechseln',
    'Toggle theme': 'Theme wechseln',
    'Sign in to download': 'Anmelden zum Herunterladen',
    'Sign in to rate': 'Anmelden zum Bewerten',
    'Author not found': 'Autor nicht gefunden',
    'Unnamed author': 'Unbenannter Autor',
    publication: 'Veröffentlichung',
    publications: 'Veröffentlichungen',
    'Boards by this author': 'Tafeln dieses Autors',
    'Link copied to clipboard': 'Link in Zwischenablage kopiert',
    'Failed to download content': 'Download fehlgeschlagen',
    'Download started': 'Download gestartet',
    'Thanks for your vote!': 'Danke für deine Stimme!',
    'Failed to send vote': 'Stimmenabgabe fehlgeschlagen',
    'Content promoted': 'Inhalt beworben',
    'View profile': 'Profil ansehen',
    'Page Size': 'Seitengröße',
    'Licenses Search': 'Lizenzen suchen',
    Licenses: 'Lizenzen',
    'Stripe Information': 'Stripe-Informationen',
    'No information': 'Keine Informationen',
    Canceled: 'Abgebrochen',
    past_due: 'Zahlung überfällig',
    active: 'Aktiv',
    'Support Areas': 'Support-Bereiche',
    Customers: 'Kunden',
    'Livox Users': 'Livox-Benutzer',
    'Distributor Totals': 'Vertriebs-Statistiken',
    'Portal Administration': 'Portalverwaltung',
    'My Devices': 'Meine Geräte',
    'My Livox Users': 'Meine Livox-Benutzer',
    'My Licenses': 'Meine Lizenzen',
    'My Authorized Users': 'Meine autorisierten Benutzer',
    'New Customer': 'Neuer Kunde',
    'Notify Customer': 'Kunden benachrichtigen',
    'New Branch': 'Neuer Zweig',
    'New Portal User': 'Neuer Portalbenutzer',
    'Install Key': 'Installationsschlüssel',
    'License Key': 'Lizenzschlüssel',
    'New License': 'Neue Lizenz',
    'New Registration Link': 'Registrierungslink erstellen',
    'All Livox users': 'Alle Livox-Benutzer',
    Home: 'Home',
    Customer: 'Kunde',
    'My Branches': 'Meine Zweige',
    Branches: 'Zweige',
    'Last Name': 'Nachname',
    Gender: 'Geschlecht',
    Age: 'Alter',
    Evaluations: 'Bewertungen',
    'Last Evalution': 'Letzte Bewertung',
    License: 'Lizenz',
    Key: 'Schlüssel',
    Status: 'Status',
    City: 'Stadt',
    State: 'Bundesland',
    Country: 'Land',
    Available: 'Verfügbar',
    Active: 'Aktiv',
    Inactive: 'Inaktiv',
    Phone: 'Telefon',
    'First Name': 'Vorname',
    'Device Name': 'Gerätename',
    Version: 'Version',
    'Remove Device': 'Gerät entfernen',
    User: 'Benutzer',
    Contact: 'Kontakt',
    Diagnosis: 'Diagnose',
    Device: 'Gerät',
    'Delete User': 'Benutzer löschen',
    'My Users': 'Meine Benutzer',
    Expire: 'Ablaufdatum',
    Support: 'Support',
    Dates: 'Daten',
    'Expiration Date': 'Ablaufdatum',
    'Support Date': 'Support-Datum',
    'Click to edit expiration date':
      'Klicken Sie, um das Ablaufdatum zu bearbeiten',
    'Click to edit support date':
      'Klicken Sie, um das Support-Datum zu bearbeiten',
    'Expiration date updated successfully':
      'Ablaufdatum erfolgreich aktualisiert',
    'Support date updated successfully':
      'Support-Datum erfolgreich aktualisiert',
    'Failed to update expire date':
      'Fehler beim Aktualisieren des Ablaufdatums',
    'Failed to update support date':
      'Fehler beim Aktualisieren des Support-Datums',
    'MAC Address': 'MAC-Adresse',
    'Device Version': 'Geräteversion',
    Name: 'Name',
    'Num. Licenses': 'Anzahl der Lizenzen',
    Activated: 'Aktiviert',
    Inactivated: 'Deaktiviert',
    Email: 'E-Mail',
    'My Auth Users': 'Meine Portalbenutzer',
    Holder: 'Inhaber',
    'Customer Licenses': 'Kundenlizenzen',
    Type: 'Typ',
    Distribution: 'Vertrieb',
    Language: 'Sprache',
    Reseller: 'Wiederverkäufer',
    Text: 'Text',
    'Number of Devices': 'Anzahl der Geräte',
    'Lifetime License': 'Lifetime-Lizenz',
    Address: 'Adresse',
    Zipcode: 'Postleitzahl',
    Neighborhood: 'Nachbarschaft',
    'Contact Email': 'Kontakt-E-Mail',
    'Confirm Contact Email': 'Kontakt-E-Mail bestätigen',
    'First name': 'Vorname',
    'Last name': 'Nachname',
    Group: 'Gruppe',
    Password: 'Passwort',
    Male: 'Männlich',
    Female: 'Weiblich',
    'My Portal Users': 'Meine Portalbenutzer',
    'Edit Profile': 'Profil bearbeiten',
    'Change Password': 'Passwort ändern',
    Register: 'Registrieren',
    'I forgot my password': 'Ich habe mein Passwort vergessen',
    Account: 'Konto',
    'No results': 'Keine Ergebnisse',
    'Customers Search': 'Kundensuche',
    Search: 'Suchen',
    'Search by name or email': 'Suche nach Name oder E-Mail',
    'Tree view': 'Baumansicht',
    'Table view': 'Tabellenansicht',
    Download: 'Herunterladen',
    'Registration Link': 'Registrierungslink',
    Page: 'Seite',
    of: 'von',
    results: 'Ergebnisse',
    'View Branches': 'Zweige anzeigen',
    'View Users': 'Benutzer anzeigen',
    Cancel: 'Abbrechen',
    Create: 'Erstellen',
    'Branch Name': 'Zweigname',
    'Confirm Password': 'Passwort bestätigen',
    'Customer Branches': 'Kundenzweige',
    'My Evaluations': 'Meine Bewertungen',
    'Livox User': 'Livox-Benutzer',
    'Add Branch': 'Zweig hinzufügen',
    'Distributor Customers': 'Vertriebskunden',
    'New Support Area': 'Neuer Support-Bereich',
    'Assign Users': 'Benutzer zuweisen',
    'Assign Customers': 'Kunden zuweisen',
    Dashboard: 'Dashboard',
    'Unique users by day': 'Einzigartige Benutzer pro Tag',
    'Users by language': 'Benutzer nach Sprache',
    'Users by country': 'Benutzer nach Land',
    Devices: 'Geräte',
    'Manage my devices': 'Meine Geräte verwalten',
    News: 'Nachrichten',
    'Read more': 'Mehr lesen',
    'Total Licenses': 'Gesamtanzahl Lizenzen',
    'Paid Licenses': 'Bezahlte Lizenzen',
    'Free Licenses': 'Kostenlose Lizenzen',
    'Distributor Stats': 'Vertriebs-Statistiken',
    Users: 'Benutzer',
    Remove: 'Entfernen',
    Evaluate: 'Bewerten',
    'Cognitive Evaluation': 'Kognitive Bewertung',
    'Recognizes images': 'Erkennt Bilder',
    'Notion of cause and effect': 'Vorstellung von Ursache und Wirkung',
    'Has notion of body awareness': 'Körperbewusstsein haben',
    'Has symbolic representation': 'Hält symbolische Darstellungen',
    'Makes choices': 'Trifft Entscheidungen',
    Literate: 'Alphabetisiert',
    'Auditory Agnosia': 'Auditive Agnosie',
    'Cow mooing': 'Kuh muht',
    'Chicken clucking': 'Huhn gackert',
    'Dog barking': 'Hund bellt',
    Doorbell: 'Türklingel',
    Sirens: 'Sirenen',
    'Visual Agnosia': 'Visuelle Agnosie',
    Dog: 'Hund',
    Cat: 'Katze',
    Bird: 'Vogel',
    House: 'Haus',
    Banana: 'Banane',
    Grapes: 'Trauben',
    Pineapple: 'Ananas',
    Watermelon: 'Wassermelone',
    Telephone: 'Telefon',
    Car: 'Auto',
    Shoe: 'Schuh',
    Ball: 'Ball',
    'Visual Oral Language': 'Visuelle mündliche Sprache',
    'Where is the ball?': 'Wo ist der Ball?',
    'Where is the doll?': 'Wo ist die Puppe?',
    'Are you at home?': 'Bist du zu Hause?',
    'What is the name of your mother?': 'Wie heißt deine Mutter?',
    'What is your name?': 'Wie heißt du?',
    'Does he/she know his/her birthday?':
      'Kennt er/sie seinen/ihren Geburtstag?',
    'Does he/she know his/her name?': 'Kennt er/sie seinen/ihren Namen?',
    'Does he/she orient to date/time?':
      'Orientiert er/sie sich nach Datum/Uhrzeit?',
    'Can he/she follow one step directions?':
      'Kann er/sie einfache Anweisungen befolgen?',
    'Can he/she follow two step directions?':
      'Kann er/sie komplexe Anweisungen befolgen?',
    'Behavior Evaluation': 'Verhaltensbewertung',
    'Does he/she bite?': 'Beißt er/sie?',
    'Does he/she hit his/her head on the wall?':
      'Schlägt er/sie den Kopf gegen die Wand?',
    'Does he/she understand feelings?': 'Versteht er/sie Gefühle?',
    'Does he/she sleep well?': 'Schläft er/sie gut?',
    General: 'Allgemein',
    'Does he/she cry?': 'Weint er/sie?',
    'Does he/she have temper tantrums?': 'Hat er/sie Wutanfälle?',
    'Is he/she aggressive?': 'Ist er/sie aggressiv?',
    'Does he/she eat well?': 'Isst er/sie gut?',
    'Does he/she run from one place to another?':
      'Rennt er/sie von einem Ort zum anderen?',
    'Does he/she focus in an activity?':
      'Konzentriert er/sie sich auf eine Aktivität?',
    'Does he/she play with other children?':
      'Spielt er/sie mit anderen Kindern?',
    'Does he/she have a hard time to sleep?':
      'Hat er/sie Schwierigkeiten beim Schlafen?',
    'Does he/she like to be alone?': 'Ist er/sie gerne alleine?',
    'Does he/she demonstrate joint attention?':
      'Zeigt er/sie gemeinsame Aufmerksamkeit?',
    'Does he/she scream?': 'Schreit er/sie?',
    'Is he/she hypersensitive to sensory stimuli?':
      'Ist er/sie überempfindlich auf sensorische Reize?',
    'Is he/she unaware to sensory stimuli?':
      'Ist er/sie unempfindlich auf sensorische Reize?',
    Holders: 'Inhaber',
    Purcharse: 'Kaufen',
    Edit: 'Bearbeiten',
    Delete: 'Löschen',
    'E-mail': 'E-Mail',
    'Full Name': 'Vollständiger Name',
    'Phone Number': 'Telefonnummer',
    Save: 'Speichern',
    Undo: 'Rückgängig',
    Publish: 'Veröffentlichen',
    'New Item': 'Neuer Artikel',
    Attributes: 'Attribute',
    'Display Text': 'Anzeigetext',
    'Spoken Phrase': 'Gesprochener Satz',
    'Expand image on click': 'Bild bei Klick vergrößern',
    Colors: 'Farben',
    Pictures: 'Bilder',
    'Search a symbol': 'Nach einem Symbol suchen',
    'Field Changed': 'Feld geändert',
    'Old Value': 'Alter Wert',
    'New Value': 'Neuer Wert',
    'License History': 'Lizenzverlauf',
    Branch: 'Zweig',
    'Evaluation Date': 'Bewertungsdatum',
    'Branch Licenses': 'Zweig-Lizenzen',
    'Add Licenses to Branch': 'Lizenzen zum Zweig hinzufügen',
    Confirm: 'Bestätigen',
    Close: 'Schließen',
    'Livox version distribution': 'Verteilung der Livox-Version',
    'Expires in': 'Läuft ab in',
    'Support ends': 'Support endet',
    available: 'verfügbar',
    'Android OS distribution': 'Verteilung des Android-Betriebssystems',
    likes: 'Gefällt mir',
    downloads: 'Downloads',
    'Reviewed at': 'Überprüft am',
    Comment: 'Kommentar',
    Pending: 'Ausstehend',
    Approved: 'Genehmigt',
    Archived: 'Archiviert',
    Accept: 'Akzeptieren',
    Reject: 'Ablehnen',
    Reason: 'Grund',
    Rejected: 'Abgelehnt',
    'Create License Registration Link':
      'Erstellen Sie einen Lizenz-Registrierungslink',
    'Create separate install keys':
      'Erstellen Sie separate Installationsschlüssel',
    'Log Out': 'Abmelden',
    'Evaluate Livox User': 'Bewerten Sie Livox-Benutzer',
    Billing: 'Abrechnung',
    'Acquire Livox': 'Livox erwerben',
    'You are about to purchase the best alternative comunication app in the world!':
      'Sie sind im Begriff, die beste alternative Kommunikations-App der Welt zu kaufen!',
    '1. Select a Plan': '1. Wählen Sie einen Plan',
    BASIC: 'BASIC',
    'Up to 3 users': 'Bis zu 3 Benutzer',
    'Smart Scan': 'Smart Scan',
    'IntelliTouch - Touch Correction': 'IntelliTouch - Touch-Korrektur',
    'Virtual keyboard': 'Virtuelle Tastatur',
    'Stock Images (20,000 images)': 'Stockbilder (20.000 Bilder)',
    'Creation of pedagogical content': 'Erstellung von pädagogischen Inhalten',
    'Voice, text and image customization':
      'Anpassung von Stimme, Text und Bild',
    'Content transfer between tablets': 'Inhaltstransfer zwischen Tablets',
    '/ month': 'pro Monat',
    'on a yearly plan': 'im Jahresplan',
    PLUS: 'PLUS',
    'Recommended for families': 'Empfohlen für Familien',
    'New Features Update': 'Update neuer Funktionen',
    'Trigger Control': 'Trigger-Kontrolle',
    'Livox control with the blink of an eye':
      'Livox-Kontrolle mit einem Augenblick',
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      'Intelligente Empfehlungen für Artikel basierend auf Zeit und Ort',
    PRO: 'PRO',
    'Recommended for professionals!': 'Empfohlen für Fachleute!',
    'UNLIMITED Users': 'UNBEGRENZTE Benutzer',
    'Complete assessment and content tool to track users progress with Livox (patients or students)':
      'Komplettes Bewertungs- und Inhaltswerkzeug zur Verfolgung des Benutzerfortschritts mit Livox (Patienten oder Studenten)',
    '2. Select a payment plan': '2. Wählen Sie einen Zahlungsplan',
    monthly: 'monatlich',
    quarterly: 'vierteljährlich',
    '% off': '% Rabatt',
    yearly: 'jährlich',
    '3. Confirm the value': '3. Bestätigen Sie den Wert',
    'per month': 'pro Monat',
    'Proceed with the checkout': 'Mit der Kasse fortfahren',
    'Select a Plan': 'Einen Plan auswählen',
    Continue: 'Weiter',
    'Get Livox': 'Livox erhalten',
    'Select a Plan - Livox Portal': 'Wählen Sie einen Plan - Livox-Portal',
    '1. Confirm your Plan': '1. Bestätigen Sie Ihren Plan',
    '3. Confirm the plan': '3. Bestätigen Sie den Plan',
    Checkout: 'Zur Kasse',
    'Secure checkout': 'Sichere Zahlung',
    'per year': 'pro Jahr',
    Change: 'Ändern',
    'per quarter': 'pro Quartal',
    'Cardholder Name': 'Name des Karteninhabers',
    'Street address': 'Straße',
    'Apartment / Suite / Unit / Building':
      'Wohnung / Suite / Einheit / Gebäude',
    'Billing Address': 'Rechnungsadresse',
    'Payment Info': 'Zahlungsinformationen',
    'Credit or debit card': 'Kredit- oder Debitkarte',
    'Credit card info secured by': 'Kreditkarteninformationen gesichert durch',
    Success: 'Erfolg',
    'Upload from .zip file here': 'Laden Sie die Zip-Datei hier hoch',
    'Published Title': 'Veröffentlichter Titel',
    'Publish Content': 'Inhalt veröffentlichen',
    'Cover Image': 'Titelbild',
    'Upload Image': 'Bild hochladen',
    Buy: 'Kaufen',
    Boards: 'Boards',
    'Thanks for purchasing Livox': 'Danke für den Kauf von Livox',
    'We are processing your payment, a receipt will be sent to':
      'Wir verarbeiten Ihre Zahlung, eine Quittung wird gesendet an',
    'with instructions on how to activate Livox.':
      'mit Anweisungen zur Aktivierung von Livox.',
    'If you have any questions/issues': 'Bei Fragen/Problemen',
    'contact our support.': 'kontaktieren Sie unseren Support.',
    Deleted: 'Gelöscht',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      'Sie haben dieses Board erfolgreich zur Überprüfung eingereicht, bitte warten Sie bis zu 48 Stunden auf die Genehmigung.',
    'You have successfully registered, Please return to the tablet to proceed.':
      'Sie haben sich erfolgreich registriert, kehren Sie bitte zum Tablet zurück, um fortzufahren.',
    'Validation notEmpty on coverImage failed':
      'Bitte fügen Sie ein Bild zu Ihrer Veröffentlichung hinzu',
    'You are not logged in. Create your account to see more of this content':
      'Sie sind nicht eingeloggt. Erstellen Sie ein Konto, um mehr von diesem Inhalt zu sehen.',
    'Buy Livox': 'Livox kaufen',
    'Select your plan and payment method to get started.':
      'Wählen Sie Ihren Plan und Ihre Zahlungsmethode, um zu beginnen.',
    'payment.pageDescription':
      'Wählen Sie Ihren Plan und Ihre Zahlungsmethode, um den Kauf abzuschließen.',
    'payment.propaganda':
      'Sie sind dabei, die beste alternative Kommunikations-App der Welt zu erwerben!',
    'payment.activeSubscriptionsCount': '{{count}} aktive(s) Abonnement(s)',
    'payment.youHaveLicenses': 'Sie haben aktive Lizenzen.',
    'payment.viewLicensesHere': 'Lizenzen hier anzeigen',
    'payment.youHaveActiveSubscriptions': 'Sie haben aktive Abonnements.',
    'payment.viewMyAssessments': 'Anzeigen in Meine Bewertungen',
    'payment.viewMySubscriptions': 'Anzeigen in Meine Abonnements',
    'payment.onlyPortugueseTitle': 'Zahlung nicht verfügbar',
    'payment.onlyPortugueseAvailable':
      'Die Zahlung ist derzeit nur auf Portugiesisch verfügbar.',
    'payment.blockedInBrazilTitle': 'Zahlung in Ihrer Region nicht verfügbar',
    'payment.blockedInBrazil':
      'Online-Zahlung ist für Zugriffe aus Brasilien nicht verfügbar.',
    'payment.blockedContactTitle': 'Kontaktieren Sie uns:',
    'payment.blockedContactBrazil':
      'Brasilien\n+55 81 97108 3009 (Telefon und WhatsApp)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brasilien, CEP: 53140-080',
    'payment.blockedContactUS':
      'USA\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'Jordanien\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      'Sie haben keine Lizenzen. Jetzt kaufen, um mit Livox zu starten!',
    Media: 'Medien',
    'Upload an image or video': 'Bild oder Video hochladen',
    'No image': 'Kein Bild',
    'Welcome to your boards page': 'Willkommen auf Ihrer Board-Seite',
    'Assistive Technology': 'Assistive Technologie',
    '1. Create': '1. Erstellen',
    'To get started, use the Livox Studio to create cards, upload images, music and videos':
      'Um anzufangen, verwenden Sie das Livox Studio, um Karten zu erstellen, Bilder, Musik und Videos hochzuladen',
    '2. Publish': '2. Veröffentlichen',
    'Submit your content to be published in the store':
      'Reichen Sie Ihren Inhalt zur Veröffentlichung im Store ein',
    '3. Get feedback': '3. Holen Sie sich Feedback',
    'Receive feedback and satisfaction from seeing your content being used all around the globe!':
      'Erhalten Sie Feedback und Zufriedenheit, indem Sie sehen, dass Ihr Inhalt weltweit genutzt wird!',
    'Livox Portal': 'Livox-Portal',
    'A content store made for you!':
      'Ein Content-Store, der für Sie gemacht wurde!',
    'The best portal for assistive technologies in the world!':
      'Das beste Portal für assistive Technologien der Welt!',
    'Learn More': 'Mehr erfahren',
    'Recent Items': 'Kürzliche Artikel',
    by: 'von',
    'Untitled Content': 'Unbenannter Inhalt',
    'Loading...': 'Laden...',
    'Click here to add a title':
      'Klicken Sie hier, um einen Titel hinzuzufügen',
    'Portuguese (BR)': 'Portugiesisch (BR)',
    English: 'Englisch',
    Arabic: 'Arabisch',
    German: 'Deutsch',
    'No boards found': 'Keine Boards gefunden',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      'Durch das Entfernen dieses Geräts wird der Benutzer von der App abgemeldet. Sind Sie sicher, dass Sie dieses Gerät entfernen möchten?',
    'New User': 'Neuer Benutzer',
    'Login as another user': 'Als anderer Benutzer anmelden',
    Technical: 'Technisch',
    Pedagogical: 'Pädagogisch',
    Results: 'Ergebnisse',
    'Top Rated Items': 'Top-Bewertete Artikel',
    'Back to Livox Portal': 'Zurück zum Livox-Portal',
    'No Categories': 'Keine Kategorien',
    Author: 'Autor',
    'No votes yet': 'Noch keine Stimmen',
    'Rate this content': 'Bewerten Sie diesen Inhalt',
    'You must be logged in to vote on this content!':
      'Sie müssen eingeloggt sein, um diesen Inhalt zu bewerten!',
    'Go to Livox Store': 'Zum Livox Store gehen',
    'Go to Play Store': 'Zum Play Store gehen',
    'Sign Up': 'Anmelden',
    Login: 'Einloggen',
    'Log In': 'Einloggen',
    'License Availability': 'Lizenzverfügbarkeit',
    'My Profile': 'Mein Profil',
    'No description available': 'Keine Beschreibung verfügbar',
    Publications: 'Veröffentlichungen',
    'User Profile': 'Benutzerprofil',
    'New user': 'Neuer Benutzer',
    'Livox Users Growth': 'Livox Benutzerwachstum',
    'Users Disability Distribution': 'Verteilung der Benutzer nach Behinderung',
    'Contact us': 'Kontaktieren Sie uns',
    'Support Type': 'Support-Typ',
    Subject: 'Betreff',
    Message: 'Nachricht',
    Send: 'Senden',
    'License Distribution': 'Lizenzverteilung',
    'Manage my licenses': 'Verwalte meine Lizenzen',
    'Show From': 'Zeigen von',
    'Only my branch': 'Nur mein Zweig',
    'All Branches': 'Alle Zweige',
    'Last Validation Date': 'Letztes Validierungsdatum',
    'Device ID': 'Geräte-ID',
    'About you': 'Über Sie',
    'No publications yet': 'Noch keine Veröffentlichungen',
    'No description available.': 'Keine Beschreibung verfügbar.',
    'Remove this livox user? ': 'Diesen Livox Benutzer entfernen?',
    'Users by city': 'Benutzer nach Stadt',
    'Create new customer': 'Neuen Kunden erstellen',
    'Boards Search': 'Boards durchsuchen',
    'Add a branch to': 'Fügen Sie einen Zweig hinzu zu',
    'Edit Branch': 'Zweig bearbeiten',
    'Edit Customer': 'Kunde bearbeiten',
    Update: 'Aktualisieren',
    'Delete Branch': 'Zweig löschen',
    'Create Branch Administrator': 'Zweigadministrator erstellen',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'Durch das Löschen dieses Zweigs werden die Benutzer und alle Lizenzen daraus entfernt. Sind Sie sicher, dass Sie diesen Zweig löschen möchten?',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'Durch das Löschen dieses Zweigs werden alle Benutzer und Lizenzen dieses Zweigs und seiner untergeordneten Zweige an den übergeordneten Zweig übertragen.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'Durch das Löschen des Stammzweigs werden Benutzer, Lizenzen, Livox-Benutzer und Lizenzinhaber dieses Kunden und aller seiner Zweige entfernt.',
    'Are you sure you want to delete this branch?':
      'Sind Sie sicher, dass Sie diesen Zweig löschen möchten?',
    'Are you sure you want to delete branch':
      'Sind Sie sicher, dass Sie den Zweig löschen möchten',
    'Delete all users of this customer and all its branches.':
      'Alle Benutzer dieses Kunden und aller seiner Zweige löschen.',
    'Delete all licenses of this customer and all its branches.':
      'Alle Lizenzen dieses Kunden und aller seiner Zweige löschen.',
    'Delete all Livox users of this customer and all its branches.':
      'Alle Livox-Benutzer dieses Kunden und aller seiner Zweige löschen.',
    'Delete all holders of this customer and all its branches.':
      'Alle Lizenzinhaber dieses Kunden und aller seiner Zweige löschen.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'Alle Benutzer dieses Zweigs und seiner Unterzweige an den übergeordneten Zweig übertragen.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'Alle Lizenzen dieses Zweigs und seiner Unterzweige an den übergeordneten Zweig übertragen.',
    'Remove this branch and its child branch structure.':
      'Diesen Zweig und die Struktur seiner Unterzweige entfernen.',
    'Reset Password': 'Passwort zurücksetzen',
    'years ago': 'Jahre her',
    'months ago': 'Monate her',
    'days ago': 'Tage her',
    'hours ago': 'Stunden her',
    'minutes ago': 'Minuten her',
    'seconds ago': 'Sekunden her',
    'Livox app is outdated on this device':
      'Die Livox-App ist auf diesem Gerät veraltet',
    'Sort By...': 'Sortieren nach...',
    'Device Android Id': 'Android-Geräte-ID',
    Saved: 'Gespeichert',
    'Saving...': 'Speichern...',
    'Error! Please refresh the page.': 'Fehler! Bitte Seite aktualisieren.',
    Review: 'Überprüfen',
    'Upload an audio or video': 'Ein Audio oder Video hochladen',
    'All Languages': 'Alle Sprachen',
    Portuguese: 'Portugiesisch (BR)',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      'Indem Sie auf "Veröffentlichen" klicken, stimmen Sie zu, dass Sie unsere',
    'terms of use': 'Nutzungsbedingungen gelesen und akzeptiert haben',
    'Add a shortcut...': 'Eine Verknüpfung hinzufügen...',
    ExampleShortcut:
      'Zum Beispiel: "Was möchtest du essen?" für ein Essen-Board.',
    'Create voice commands to open this board on Livox app!':
      'Erstellen Sie Sprachbefehle, um dieses Board in der Livox-App zu öffnen!',
    Shortcuts: 'Verknüpfungen',
    'NEW!': 'NEU!',
    NEW: 'NEU',
    'Uploading...': 'Hochladen...',
    'Processing files...': 'Dateien werden verarbeitet...',
    'The file you uploaded is too large.':
      'Die hochgeladene Datei ist zu groß.',
    'Error: File too large': 'Fehler: Datei zu groß',
    'Error: Sorry we just encountered an unexpected error, please try again':
      'Fehler: Entschuldigung, ein unerwarteter Fehler ist aufgetreten. Bitte erneut versuchen.',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      'Fehler: Die Zip-Datei scheint beschädigt zu sein oder ist kein Livox-Inhalt',
    'Are you sure you want to delete this content?':
      'Sind Sie sicher, dass Sie diesen Inhalt löschen möchten?',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'Fehler: Ungültiger Inhalt, bitte stellen Sie sicher, dass die hochgeladene Datei eine .zip-Datei ist',
    'Get Started': 'Loslegen',
    'Record a new shortcut via voice':
      'Eine neue Verknüpfung per Sprache aufnehmen',
    'You have blocked this website of using the Microphone.':
      'Sie haben dieser Website die Verwendung des Mikrofons untersagt.',
    "Couldn't detect speech, please check your microphone settings.":
      'Sprache nicht erkannt, bitte überprüfen Sie Ihre Mikrofoneinstellungen.',
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      'Ihr Browser ist nicht kompatibel mit der Speech Recognition API, aber Sie können die Verknüpfungen unten manuell eingeben.',
    'Error while recording shortcut, please try again':
      'Fehler beim Aufnehmen der Verknüpfung, bitte versuchen Sie es erneut.',
    Features: 'Funktionen',
    'Voice Shortcuts': 'Sprachverknüpfungen',
    'Add shortcuts to this folder': 'Verknüpfungen zu diesem Ordner hinzufügen',
    shortcuts: 'Verknüpfungen',
    'You have pending reviews': 'Es gibt ausstehende Bewertungen',
    'No pending reviews': 'Keine ausstehenden Bewertungen',
    'Admin Portal': 'Admin-Portal',
    'Log out': 'Abmelden',
    'Zip Overwrite': 'Mit Zip überschreiben',
    Share: 'Teilen',
    'Used Licenses': 'Benutzte Lizenzen',
    'Last Registered Activity': 'Letzte registrierte Aktivität',
    'Interactions by time of day': 'Interaktionen nach Tageszeit',
    'Avg. Interactions / User': 'Durchschn. Interaktionen / Benutzer',
    Featured: 'Empfohlen',
    'Promoted Content': 'Beworbene Inhalte',
    'Rate this': 'Bewerten',
    Promote: 'Bewerben',
    'Your rating': 'Ihre Bewertung',
    Play: 'Abspielen',
    'Back to Edit': 'Zurück zur Bearbeitung',
    Next: 'Weiter',
    'Inside items': 'Innerelemente',
    Regular: 'Regulär',
    'Book Mode': 'Buchmodus',
    Fixed: 'Fixiert',
    System: 'System',
    Rows: 'Reihen',
    Collumns: 'Spalten',
    Display: 'Anzeige',
    'Page Mode': 'Seitenmodus',
    'Text Size': 'Textgröße',
    Print: 'Drucken',
    'This dashboard is made with aggregated data across all licenses':
      'Dieses Dashboard ist mit aggregierten Daten über alle Lizenzen erstellt worden',
    ' assigned to your user': ' Ihrem Benutzer zugewiesen',
    'view licenses': 'Lizenzen anzeigen',
    'No Data': 'Keine Daten',
    'Last 30 days': 'Letzte 30 Tage',
    'Last 6 months': 'Letzte 6 Monate',
    'Last year': 'Letztes Jahr',
    'Results for': 'Ergebnisse für',
    'Full Screen': 'Vollbild',
    'Cards cut — navigate and paste into empty slots':
      'Karten geschnitten — navigieren und in leere Slots einfügen',
    'No empty slots to paste into': 'Keine leeren Slots zum Einfügen',
    'Cards pasted': 'Karten eingefügt',
    'cards still to paste': 'Karten noch zum Einfügen',
    'ready to paste': 'bereit zum Einfügen',
    'Paste actions': 'Aktionen einfügen',
    'Cards grouped into folder': 'Karten in Ordner gruppiert',
    'Select at least 2 cards to group':
      'Wählen Sie mindestens 2 Karten zum Gruppieren aus',
    'New folder': 'Neuer Ordner',
    Cut: 'Ausschneiden',
    Copy: 'Kopieren',
    Paste: 'Einfügen',
    'Paste Inside': 'Innen einfügen',
    Dark: 'Dunkel',
    Light: 'Hell',
    'Card Properties': 'Karten-Eigenschaften',
    'Export PDF': 'PDF exportieren',
    'Export as PDF': 'Als PDF exportieren',
    'Export section layout': 'Layout',
    'Export section content': 'Inhalt',
    'Standard layout (grid)': 'Standardlayout (Raster)',
    'Single card (1×1 full page)': 'Einzelkarte (1×1 volle Seite)',
    'Select card to export': 'Karte zum Export auswählen',
    'Select a card': 'Wählen Sie eine Karte',
    'Current board (grid)': 'Aktuelle Tafel (Raster)',
    'Fixed bar only': 'Nur feste Leiste',
    'Board + Fixed bar': 'Tafel + Feste Leiste',
    'Main Board': 'Haupttafel',
    Part: 'Teil',
    'Cut here': 'Hier schneiden',
    'Exported on': 'Exportiert am',
    'Fixed Bar': 'Feste Leiste',
    'Cut for continuous use': 'Für den dauerhaften Einsatz zuschneiden',
    'Audio / Video': 'Audio / Video',
    'Add an audio or video': 'Audio oder Video hinzufügen',
    'Uploaded image': 'Hochgeladenes Bild',
    'On touching this board show this image, if none set it will skip the action':
      'Beim Berühren dieses Boards wird dieses Bild angezeigt, wenn keines festgelegt ist, wird die Aktion übersprungen',
    'Search an image': 'Bild suchen',
    Suggestions: 'Vorschläge',
    Images: 'Bilder',
    Publication: 'Veröffentlichung',
    'Manage Boards': 'Boards verwalten',
    'Livox Web': 'Livox Web',
    'Settings - Display': 'Einstellungen - Anzeige',
    Start: 'Start',
    Settings: 'Einstellungen',
    'Manage Users': 'Benutzer verwalten',
    Voice: 'Stimme',
    Controls: 'Steuerung',
    'Artificial Intelligence': 'Künstliche Intelligenz',
    About: 'Über',
    Test: 'Testen',
    'Voice Language': 'Sprachsprache',
    'Voice Actor': 'Stimmenschauspieler',
    'Voice speed': 'Sprechgeschwindigkeit',
    'Pitch Rate': 'Tonhöhe',
    Preview: 'Vorschau',
    'Quick chat': 'Schnellchat',
    'Font Size': 'Schriftgröße',
    'Paging Mode': 'Seitendarstellung',
    'Touch correction': 'Berührungskorrektur',
    'Time to wait between touches': 'Wartezeit zwischen Berührungen',
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      'Manuell festgelegte Zeit, um weitere Berührungen zu verhindern. Stellen Sie null Sekunden ein, um zu deaktivieren.',
    'Natural Conversation': 'Natürliche Konversation',
    'Trigger words': 'Auslösewörter',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      'Registrierte Schlüsselwörter, die Livox hört, bevor eine Aktion ausgeführt wird. Schlüsselwörter sind nicht case-sensitiv.',
    'No keywords created': 'Keine Schlüsselwörter erstellt',
    'Speak navigation arrows': 'Navigationspfeile sprechen',
    'Enable natural conversation': 'Natürliche Konversation aktivieren',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet connection.':
      'Fernsteuerliche Sprachbefehle, die je nach Kontext passende Boards zeigen können. Benötigt ein Mikrofon und Internetverbindung.',
    'Enable Intellitouch': 'Intellitouch aktivieren',
    'Recommended for users with motor disabilities. Automatically detects imperfect touches.':
      'Empfohlen für Benutzer mit motorischen Beeinträchtigungen. Erkennt automatisch ungenaue Berührungen.',
    'Delay will be set dynamically by Intellitouch.':
      'Die Verzögerung wird dynamisch von Intellitouch festgelegt.',
    Legacy: 'Altversion',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'Lizenzstatus',
    'Activity days': 'Aktivitätstage',
    'Active Usage Status': 'Status der aktiven Nutzung',
    'Above Average': 'Überdurchschnittlich',
    'Below Average': 'Unterdurchschnittlich',
    'Average Interactions':
      'Durchschnittliche Interaktionen: {{clicks}} Klicks.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      'Inaktive Lizenzen sind solche, bei denen in dem angegebenen Zeitraum kein Benutzer Livox verwendet hat.',
    'Version Status': 'Versionsstatus',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      'Geräte mit älteren Betriebssystemversionen (OS) riskieren den Zugriff auf Livox zu verlieren.',
    'Outdated OS': 'Veraltetes Betriebssystem',
    'Outdated Livox': 'Veraltetes Livox',
    'Operational System Version': 'Betriebssystemversion',
    'Device usage (%)': 'Gerätenutzung (%)',
    'Device usage': 'Gerätenutzung',
    'Disability distribution': 'Verteilung der Behinderungen',
    Period: 'Zeitraum',
    '30 days': '30 Tage',
    '45 days': '45 Tage',
    '2 months': '2 Monate',
    '6 months': '6 Monate',
    '1 year': '1 Jahr',
    'Global Active Usage': 'Globale aktive Nutzung',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      'Prozentsatz der Benutzer, die über und unter dem globalen Durchschnitt genutzt haben ({{clicks}} Klicks).',
    'Most Active': 'Am aktivsten',
    'Least Active': 'Am wenigsten aktiv',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'Die Benutzer, die 30 % über und unter Ihrem Durchschnitt verwendet haben (> {{upper_limit}} und < {{lower_limit}} jeweils).',
    'Active users are those that had at least 1 interaction on the time period.':
      'Aktive Benutzer sind diejenigen, die mindestens 1 Interaktion im Zeitraum hatten.',
    'Activity ({{days}} days)': 'Aktivität ({{days}} Tage)',
    'Dashboard Charts': 'Dashboard-Grafiken',
    'Users per disability': 'Benutzer pro Behinderung',
    'Users per age': 'Benutzer pro Alter',
    Autism: 'Autismus',
    'Amyotrophic Lateral Sclerosis': 'Amyotrophe Lateralsklerose',
    'Cerebral Palsy': 'Zerebralparese',
    'Person without disabilities': 'Person ohne Behinderungen',
    'No physical disabilities, just unable to speak':
      'Keine körperlichen Behinderungen, nur sprachunfähig',
    'Stroke Sequelae': 'Schlaganf-folge',
    'Down Syndrome': 'Down-Syndrom',
    'Brain Injury': 'Hirnschaden',
    'Another motor impairment': 'Weitere motorische Beeinträchtigung',
    'Another cognitive impairment': 'Weitere kognitive Beeinträchtigung',
    'Store Statistics': 'Shop-Statistiken',
    Creators: 'Ersteller',
    Published: 'Veröffentlicht',
    'Unique Downloads': 'Einzigartige Downloads',
    Items: 'Artikel',
    'SymbolStyx usage': 'SymbolStix Nutzung',
    'Uploaded Images': 'Hochgeladene Bilder',
    'Uploaded Audio/Video': 'Hochgeladene Audio/Video',
    'Multiple images': 'Mehrere Bilder',
    'Most used symbols': 'Meistverwendete Symbole',
    'Usage Status': 'Nutzungsstatus',
    Disclaimer: 'Haftungsausschluss',
    'basic plan disclaimer':
      'Die BASIC-Lizenz ist eine einfachere Version von Livox mit <b>weniger Funktionen</b> und <b>keinem technischen Support</b>. Normalerweise von Eltern erworben, die Livox gut kennen und z. B. ein zweites Gerät mit weniger Funktionen für den Outdoor-Einsatz ihrer Kinder wünschen.<br/>Diese Version wird nicht für Anfänger empfohlen, ist aber für diejenigen geeignet, die bereits eine PLUS-Version haben und eine BASIC für ein zweites Gerät wünschen.',
    'Available Licenses': 'Verfügbare Lizenzen',
    'Unable to log in with provided credentials.':
      'Anmeldung mit den angegebenen Anmeldedaten nicht möglich. E-Mail und/oder Passwort falsch.',
    'Renew Licenses': 'Lizenzen erneuern',
    Border: 'Rahmen',
    'It is not possible to access cards with more than one state':
      'Es ist nicht möglich, Karten mit mehr als einem Zustand zu verwenden',
    'New state': 'Neuer Zustand',
    'Only text': 'Nur Text',
    'Livox IntelliBar (Beta)': 'IntelliBar von Livox (Beta)',
    'Print navigation card': 'Navigationskarte drucken',
    'Board + IntelliBar': 'Tafel + IntelliBar',
    'AI Error': 'KI-Fehler:',
    'Create items using AI!': 'Erstellen Sie Elemente mit KI!',
    'Get cards recommendations for every situation!':
      'Erhalten Sie Kartenempfehlungen für jede Situation!',
    'Examples:': 'Beispiele:',
    'Breakfast items': 'Frühstücksartikel',
    'Teeth brushing steps': 'Zahnbürst-Schritte',
    'Quiz option choices': 'Quiz-Optionsfragen',
    'and many more!': 'und viele mehr!',
    'Cards suggestion with AI': 'Kartenvorschläge mit KI',
    '{{used}} of {{limit}} used': '{{used}} von {{limit}} belegt',
    'Insufficient JandaIA coins': 'Nicht genügend JandaIA Coins',
    'Type a topic': 'Geben Sie ein Thema ein',
    'Add card': 'Karte hinzufügen',
    'Card added to board': 'Karte zum Board hinzugefügt',
    'No empty slots available': 'Keine leeren Plätze verfügbar',
    'Failed to add card': 'Karte konnte nicht hinzugefügt werden',
    'Print all pages': 'Alle Seiten drucken',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      'Sind Sie sicher, dass Sie die Karte(n) löschen wollen? Dies kann nicht rückgängig gemacht werden!',
    'Edit Email': 'E-Mail bearbeiten',
    'Already exists an user with informed email':
      'Es existiert bereits ein Benutzer mit der angegebenen E-Mail',
    'Default Payment': 'Standardzahlung',
    'ending with': 'endet auf',
    'Expires at': 'Läuft ab am',
    'Plan details': 'Pläne-Details',
    "Passwords don't match": 'Passwörter stimmen nicht überein',
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'Passwort muss mindestens einen Großbuchstaben, einen Kleinbuchstaben, ein Sonderzeichen, eine Zahl enthalten und mindestens 8 Zeichen lang sein',
    'User Already exists': 'Benutzer existiert bereits',
    'An email will be sent to activate the account':
      'Es wird eine E-Mail gesendet, um das Konto zu aktivieren',
    'Expire month': 'Ablaufmonat',
    'Expire year': 'Ablaufjahr',
    'Select as default payment method': 'Als Standardzahlungsmethode auswählen',
    'Change Billing': 'Rechnungsdetails ändern',
    'Change card details': 'Kartendetails ändern',
    activate_license: 'Lizenz aktivieren',
    'Change Livox Plan': 'Livox-Plan ändern',
    'Due next in': 'Fällig in',
    'Cancel motive': 'Stornierungsgrund',
    'Are you sure you want to cancel the plan?':
      'Sind Sie sicher, dass Sie den Plan stornieren möchten?',
    Card: 'Karte',
    'My subscriptions': 'Meine Abonnements',
    Cards: 'Karten',
    'Welcome to Livox': 'Willkommen bei Livox',
    'enter your e-mail address': 'Geben Sie Ihre E-Mail-Adresse ein',
    'enter your password': 'Geben Sie Ihr Passwort ein',
    'Password requirements': 'Passwortanforderungen',
    'Must be at least 8 characters long': 'Muss mindestens 8 Zeichen lang sein',
    'Must include at least one uppercase letter':
      'Muss mindestens einen Großbuchstaben enthalten',
    'Must include at least one lowercase letter':
      'Muss mindestens einen Kleinbuchstaben enthalten',
    'Must include at least one number': 'Muss mindestens eine Zahl enthalten',
    'Must include at least one special character':
      'Muss mindestens ein Sonderzeichen enthalten',
    'Old Password': 'Altes Passwort',
    'New Password': 'Neues Passwort',
    'enter your old password': 'Geben Sie Ihr altes Passwort ein',
    'enter your new password': 'Geben Sie Ihr neues Passwort ein',
    'confirm your new password': 'Bestätigen Sie Ihr neues Passwort',
    'Holder Information': 'Inhaberinformationen',
    Client: 'Kunde',
    'My Subscriptions': 'Meine Abonnements',
    'Payment Methods': 'Zahlungsmethoden',
    'Payment History': 'Zahlungsverlauf',
    'Livox Cloud': 'Livox Cloud',
    'of 1TB used': 'von 1TB verwendet',
    'Portal Livox': 'Livox-Portal',
    'CONGRATS!': 'GLÜCKWUNSCH!',
    'Based on your stats you used your account':
      'Basierend auf Ihren Statistiken haben Sie Ihr Konto verwendet',
    'more than last month!': 'mehr als im letzten Monat!',
    'Regional Food': 'Regionale Speisen',
    Animals: 'Tiere',
    'The Flash Game': 'Das Blitzspiel',
    'All users': 'Alle Benutzer',
    'All period': 'Gesamter Zeitraum',
    'Last day': 'Letzter Tag',
    'Last week': 'Letzte Woche',
    'Last month': 'Letzter Monat',
    '1 month': '1 Monat',
    'User Stats': 'Benutzerstatistiken',
    'Play Games': 'Spiele spielen',
    'Play Duration': 'Spieldauer',
    '(minutes)': '(Minuten)',
    Recommendations: 'Empfehlungen',
    'Shared Content': 'Geteilter Inhalt',
    'Total number of minutes:': 'Gesamtanzahl an Minuten:',
    'Yes or No': 'Ja oder Nein',
    Fruits: 'Früchte',
    Food: 'Lebensmittel',
    'Monthly Usage': 'Monatliche Nutzung',
    'Amount of Interactions': 'Anzahl der Interaktionen',
    "Oops! It looks like you haven't shared any content yet.":
      'Oops! Es sieht so aus, als hätten Sie noch keinen Inhalt geteilt.',
    'Edit Your Profile': 'Bearbeiten Sie Ihr Profil',
    Appearance: 'Aussehen',
    'Privacy Terms': 'Datenschutz-Bestimmungen',
    'Service Terms': 'Service-Bedingungen',
    'Password Settings': 'Passworteinstellungen',
    'For up to 3 users who already know or follow up with Livox professionals.':
      'Für bis zu 3 Benutzer, die bereits Livox-Profis kennen oder betreut werden.',
    '/MONTH': '/MONAT',
    'Payment Method': 'Zahlungsmethode',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': 'Bild-Dataset',
    'Current Plan': 'Aktueller Plan',
    'Other Subscriptions': 'Andere Abonnements',
    cancel: 'Abbrechen',
    cpfOrCnpj: 'CPF oder CNPJ',
    processing: 'Verarbeitung...',
    tryAgainIn: 'Erneut versuchen in {{seconds}}s',
    'BASIC SUBSCRIPTION': 'BASIC ABONNEMENT',
    'Basic Subscription': 'Basisabonnement',
    'See as list': 'Als Liste anzeigen',
    'See as grid': 'Als Raster anzeigen',
    'HOW IT WORKS?': 'WIE FUNKTIONIERT ES?',
    '.zip upload': '.zip hochladen',
    'create board': 'Board erstellen',
    create: 'erstellen',
    upload: 'hochladen',
    feedback: 'Feedback',
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      'Um loszulegen, verwenden Sie das Livox Studio zum Erstellen von Karten und Hochladen von Bildern, Musik und Videos!',
    'Submit your content to be published in the portal!':
      'Reichen Sie Ihre Inhalte zur Veröffentlichung im Portal ein!',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      'Erhalten Sie Feedback und Zufriedenheitsbewertungen, indem Sie wissen, dass Ihre Boards weltweit genutzt werden!',
    Price: 'Preis',
    OK: 'OK',
    PENDING: 'AUSSTEHEND',
    DECLINED: 'ABGELEHNT',
    ChangeLivoxPlan: 'Livox-Plan ändern',
    'Active Plans': 'Aktive Pläne',
    'Canceled Plans': 'Stornierte Pläne',
    'Are you sure you want to cancel the plan':
      'Sind Sie sicher, dass Sie den Plan stornieren möchten?',
    'Plan changed successfully': 'Plan erfolgreich geändert',
    'Plan cancel successfully': 'Plan erfolgreich storniert',
    'Provide the reason for cancellation': 'Nennen Sie den Stornierungsgrund',
    CHANGE: 'ÄNDERN',
    paid: 'bezahlt',
    open: 'offen',
    draft: 'Entwurf',
    void: 'ungültig',
    declined: 'abgelehnt',
    uncollectible: 'uneinbringlich',
    Invoices: 'Rechnungen',
    'Wrong password.': 'Falsches Passwort.',
    "The two password fields didn't match.":
      'Die beiden Passwortfelder stimmen nicht überein.',
    'Something went wrong.': 'Etwas ist schiefgelaufen.',
    'Please fill in all required fields.':
      'Bitte füllen Sie alle Pflichtfelder aus.',
    'Password changed successfully!': 'Passwort erfolgreich geändert!',
    'Device Nickname': 'Gerätename',
    'License Information': 'Lizenzinformationen',
    to: 'zu',
    'Licenses per page': 'Lizenzen pro Seite',
    'Choose a payment method': 'Wählen Sie eine Zahlungsmethode',
    'Published Content': 'Veröffentlichter Inhalt',
    'View published content in the store':
      'Veröffentlichte Inhalte im Shop anzeigen',
    'Payment Method changed successfully':
      'Zahlungsmethode erfolgreich geändert',
    'Device removed successfully': 'Gerät erfolgreich entfernt',
    'Failed to remove device': 'Gerät konnte nicht entfernt werden',
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',
    'Evolution of use': 'Nutzungsentwicklung',
    'Use by schedule': 'Nutzung nach Zeitplan',
    '(clicks)': '(Klicks)',
    Responsible: 'Verantwortlich',
    Birthday: 'Geburtstag',
    Birthdate: 'Geburtsdatum',
    None: 'Keine',
    Mild: 'Leicht',
    Moderate: 'Mäßig',
    'Severe (Blindness)': 'Schwer (Blindheit)',
    Good: 'Gut',
    'Severe (Needs switch)': 'Schwer (Benötigt Schalter)',
    'Few physical limitations': 'Wenige körperliche Einschränkungen',
    'Dificulties in daily activities, requires assistance':
      'Schwierigkeiten bei täglichen Aktivitäten, erfordert Unterstützung',
    'Almost or totally dependent': 'Fast oder ganz abhängig',
    'Without communicative intent': 'Ohne kommunikative Absicht',
    'Does not verbalize, but has communicative intention':
      'Verbalisiert nicht, hat aber kommunikative Absicht',
    'Make sounds': 'Macht Geräusche',
    'Makes vowel unions': 'Bildet Vokalverbindungen',
    'Speak with very limited vocabulary (5-10 words)':
      'Sprechen mit sehr begrenztem Vokabular (5-10 Wörter)',
    'Speak with limited vocabulary (10-30 words)':
      'Sprechen mit begrenztem Vokabular (10-30 Wörter)',
    'Fully communicative': 'Vollständig kommunikativ',
    'Diagnosis Information': 'Diagnoseinformationen',
    'Fine motor skills': 'Feinmotorik',
    'Repetitive movements': 'Repetitive Bewegungen',
    'Hearing impairment': 'Hörbehinderung',
    'Visual impairment': 'Sehbehinderung',
    'Current communication': 'Aktuelle Kommunikation',
    'Autonomy level': 'Autonomieniveau',
    Have: 'Haben',
    'Does not have': 'Hat nicht',
    Yes: 'Ja',
    No: 'Nein',
    'Customer Admin': 'Kundenadministrator',
    'Portal Admin': 'Portaladministrator',
    'Users per page': 'Benutzer pro Seite',
    Private: 'Privat',
    Organization: 'Organisation',
    'License Usage': 'Lizenznutzung',
    'Livox Usage': 'Livox-Nutzung',
    Amount: 'Menge',
    Used: 'Verwendet',
    'Users Status': 'Benutzerstatus',
    'active users': 'aktive Benutzer',
    Disability: 'Behinderung',
    'Portal Users': 'Portal-Benutzer',
    'Last Validation': 'Letzte Validierung',
    Subscriptions: 'Abonnements',
    'Public?': 'Öffentlich?',
    'Avaiable?': 'Verfügbar?',
    'Searching for boards from all your users':
      'Suche nach Boards von allen Ihren Benutzern',
    'Your filters did not find results':
      'Ihre Filter haben keine Ergebnisse gefunden',
    'not found': 'nicht gefunden',
    "It looks like your users haven't created boards yet":
      'Es sieht so aus, als hätten Ihre Benutzer noch keine Boards erstellt',
    'no boards': 'keine Boards',
    'Searching for your boards': 'Suche nach Ihren Boards',
    'Find boards created by users in your organization here':
      'Hier finden Sie Boards, die von Benutzern in Ihrer Organisation erstellt wurden',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      'Durch das Entfernen dieser Geräte wird der Benutzer von der App abgemeldet. Sind Sie sicher, dass Sie {{count}} Gerät entfernen möchten?',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      'Durch das Entfernen dieses Geräts wird der Benutzer von der App abgemeldet. Sind Sie sicher, dass Sie dieses Gerät entfernen möchten?',
    '{{count}} devices removed successfully':
      '{{count}} Geräte erfolgreich entfernt',
    '{{count}} devices failed to be removed':
      '{{count}} Geräte konnten nicht entfernt werden',
    'Branch removed successfully': 'Zweig erfolgreich entfernt',
    'Failed to remove branch': 'Zweig konnte nicht entfernt werden',
    'Branches moved successfully': 'Zweige erfolgreich verschoben',
    'Failed to move branches': 'Zweige konnten nicht verschoben werden',
    'Move branches to:': 'Zweige verschieben nach:',
    Move: 'Verschieben',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'Einige ausgewählte Zweige haben Unterzweige. Alle Unterzweige werden ebenfalls verschoben.',
    'Parent Branch': 'Übergeordneter Zweig',
    Root: 'Wurzel',
    'Sub-branch of': 'Unterzweig von',
    'Branch created successfully!': 'Zweig erfolgreich erstellt!',
    'Email already registered': 'E-Mail bereits registriert',
    'Branch updated successfully!': 'Zweig erfolgreich aktualisiert!',
    'Create Branch': 'Zweig erstellen',
    'Update Branch': 'Zweig aktualisieren',
    'Edit Publication': 'Veröffentlichung bearbeiten',
    'My Assessments': 'Meine Bewertungen',
    'Assessments Details': 'Bewertungsdetails',
    Assessment: 'Bewertung',
    'Assessments per page': 'Bewertungen pro Seite',
    Finish: 'Beenden',
    'General assessment': 'Allgemeine Bewertung',
    'Temporal assessment': 'Zeitliche Bewertung',
    'Assessment average': 'Durchschnittliche Bewertung',
    Cognitive: 'Kognitiv',
    Auditory: 'Auditiv',
    Visual: 'Visuell',
    Oral: 'Mündlich',
    Behaviour: 'Verhalten',
    Geral: 'Allgemein',
    'Add comment': 'Kommentar hinzufügen',
    'Enter your comment for this assessment':
      'Geben Sie Ihren Kommentar für diese Bewertung ein',
    'Assessment added successfully!': 'Bewertung erfolgreich hinzugefügt!',
    'Failed to add assessments': 'Bewertungen konnten nicht hinzugefügt werden',
    'New assessment': 'Neue Bewertung',
    'Customer Support': 'Kundensupport',
    Promoted: 'Befördert',
    Statistics: 'Statistiken',
    Details: 'Einzelheiten',
    Refuse: 'Ablehnen',
    Approve: 'Genehmigen',
    'Content Details': 'Inhaltsdetails',
    'boards per page': 'Boards pro Seite',
    'Searching for pending content...': 'Suche nach ausstehendem Inhalt...',
    'Searching for promoted content...': 'Suche nach beworbenem Inhalt...',
    'Searching for published content...':
      'Suche nach veröffentlichtem Inhalt...',
    Created: 'Erstellt',
    Demote: 'Zurückstufen',
    'Demote Publication': 'Veröffentlichung zurückstufen',
    'Do you want to demote this content?':
      'Möchten Sie diesen Inhalt zurückstufen?',
    'Approve Publication': 'Veröffentlichung genehmigen',
    'Do you approve this publication?':
      'Genehmigen Sie diese Veröffentlichung?',
    'Original language': 'Originalsprache',
    'Translate into (optional)': 'Übersetzen in (optional)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'Das Board wurde in dieser Sprache verfasst, nicht in der bei der Einreichung angegebenen. Der vorhandene Inhalt wird neu gekennzeichnet, nicht übersetzt.',
    'Reject Publication': 'Veröffentlichung ablehnen',
    'Enter the comment for this rejection':
      'Geben Sie den Kommentar für diese Ablehnung ein',
    'Remove Publication': 'Veröffentlichung entfernen',
    'Download count': 'Anzahl der Downloads',
    'Successfully promoted!': 'Erfolgreich beworben!',
    'An error occurred while promoting.':
      'Beim Bewerben ist ein Fehler aufgetreten.',
    'Upload a banner to promote this board.':
      'Laden Sie ein Banner hoch, um dieses Board zu bewerben.',
    'Successfully published board!': 'Board erfolgreich veröffentlicht!',
    'Successfully updated board!!': 'Board erfolgreich aktualisiert!',
    'An error occurred while submitting.':
      'Beim Übermitteln ist ein Fehler aufgetreten.',
    'Increase the description to at least 10 characters.':
      'Erweitern Sie die Beschreibung auf mindestens 10 Zeichen.',
    'Publish board': 'Board veröffentlichen',
    'Board submitted for review!': 'Board zur Überprüfung eingereicht!',
    'Please upload a cover image.': 'Bitte laden Sie ein Titelbild hoch.',
    'The board will be reviewed by an administrator before it appears in the store.':
      'Das Board wird von einem Administrator überprüft, bevor es im Store erscheint.',
    'Enter description': 'Beschreibung eingeben',
    'Enter title': 'Titel eingeben',
    'Enter subtitle': 'Untertitel eingeben',
    Subtitle: 'Untertitel',
    'Email successfully sent!!!': 'E-Mail erfolgreich gesendet!!!',
    'Error sending email!': 'Fehler beim Senden der E-Mail!',
    'The content has been demoted!': 'Der Inhalt wurde zurückgestuft!',
    'Failed to demote content!': 'Inhalt konnte nicht zurückgestuft werden!',
    'Publication successfully approved!':
      'Veröffentlichung erfolgreich genehmigt!',
    'Failed to approve!': 'Genehmigung fehlgeschlagen!',
    'Publication successfully rejected!':
      'Veröffentlichung erfolgreich abgelehnt!',
    'Failed to reject!': 'Ablehnung fehlgeschlagen!',
    Activity: 'Aktivität',
    'License Activity': 'Lizenzaktivität',
    'Active Licenses': 'Aktive Lizenzen',
    'Inactive Licenses': 'Inaktive Lizenzen',
    'User Activity': 'Benutzeraktivität',
    'Removing this sponsor will revoke access to the dashboard and clear all licenses assigned to them.':
      'Das Entfernen dieses Sponsors widerruft den Zugriff auf das Dashboard und löscht alle ihnen zugewiesenen Lizenzen.',
    'Are you sure you want to delete this sponsor?':
      'Sind Sie sicher, dass Sie diesen Sponsor löschen möchten?',
    'The sponsor has been deleted!': 'Der Sponsor wurde gelöscht!',
    'Failed to remove sponsor!': 'Sponsor konnte nicht entfernt werden!',
    'Sponsor created successfully!': 'Sponsor erfolgreich erstellt!',
    'Create Sponsor': 'Sponsor erstellen',
    'enter sponsor name...': 'Sponsorname eingeben...',
    'enter email...': 'E-Mail eingeben...',
    'New Sponsor': 'Neuer Sponsor',
    Sponsors: 'Sponsoren',
    'Projects Details': 'Projekt Details',
    'Project Dashboard': 'Projekt-Dashboard',
    'Sponsors per page': 'Sponsoren pro Seite',
    'Assign Licenses': 'Lizenzen zuweisen',
    '{{count}} licenses successfully assigned':
      '{{count}} Lizenzen erfolgreich zugewiesen',
    'Failed to assign licenses': 'Lizenzen konnten nicht zugewiesen werden',
    'Assign licenses to sponsor': 'Lizenzen einem Sponsor zuweisen',
    'Sponsor Licenses': 'Lizenz des Sponsors',
    'Sponsored Projects': 'Gesponserte Projekte',
    'Remove Licenses': 'Lizenzen entfernen',
    'Remove licenses from sponsor': 'Lizenzen vom Sponsor entfernen',
    '{{count}} licenses successfully removed':
      '{{count}} Lizenzen erfolgreich entfernt',
    'Failed to remove licenses': 'Lizenzen konnten nicht entfernt werden',
    'Create Portal User': 'Portal-Benutzer erstellen',
    'enter first name...': 'Vorname eingeben...',
    'enter last name...': 'Nachname eingeben...',
    'enter a password...': 'Passwort eingeben...',
    'You do not have active plans': 'Sie haben keine aktiven Pläne',
    'You do not have canceled plans': 'Sie haben keine stornierten Pläne',
    'searching for your payment methods':
      'Suche nach Ihren Zahlungsmethoden...',
    'You have no payment methods': 'Sie haben keine Zahlungsmethoden',
    failed: 'fehlgeschlagen',
    'Your token is invalid or has expired':
      'Ihr Token ist ungültig oder abgelaufen',
    'Password does not meet the minimum security requirements':
      'Das Passwort erfüllt nicht die Mindestanforderungen an die Sicherheit.',
    'Passwords do not match.': 'Passwörter stimmen nicht überein.',
    'Resetting...': 'Zurücksetzen...',
    'validating your token': 'Validierung Ihres Tokens',
    'Password successfully changed!': 'Passwort erfolgreich geändert!',
    'Error changing password!': 'Fehler beim Ändern des Passworts!',
    'enter branch name': 'Zweignamen eingeben',
    'enter branch address': 'Zweigadresse eingeben',
    'enter customer name': 'Kundenname eingeben',
    'enter customer address': 'Kundenadresse eingeben',
    'enter city': 'Stadt eingeben',
    'enter zip code': 'Postleitzahl eingeben',
    'enter state': 'Bundesland eingeben',
    'enter phone number': 'Telefonnummer eingeben',
    'Unauthorized Access': 'Unbefugter Zugriff',
    'You do not have permission to view this page with your current role.':
      'Sie haben keine Berechtigung, diese Seite mit Ihrer aktuellen Rolle anzusehen.',
    'Page Not Found': 'Seite nicht gefunden',
    'Sorry, the page you are looking for doesn’t exist.':
      'Entschuldigung, die gesuchte Seite existiert nicht.',
    'Este campo não pode ser em branco.': 'Dieses Feld darf nicht leer sein.',
    'no licenses': 'Keine Lizenzen',
    'You do not have any licenses available.':
      'Sie haben keine verfügbaren Lizenzen.',
    licenses: 'Lizenzen',
    users: 'Benutzer',
    Quantity: 'Menge',
    Indicator: 'Indikator',
    Value: 'Wert',
    Category: 'Kategorie',
    Aggregate: 'Aggregat',
    'Customers per page': 'Kunden pro Seite',
    'Holders per page': 'Inhaber pro Seite',
    'Searching for your licenses': 'Suche nach Ihren Lizenzen',
    'There are no promoted boards': 'Es gibt keine beworbenen Boards',
    'There are no pending boards': 'Es gibt keine ausstehenden Boards',
    'No data was found for this chart.':
      'Für dieses Diagramm wurden keine Daten gefunden.',
    Sponsor: 'Sponsor',
    'My Projects': 'Meine Projekte',
    'Invalid Date': 'Ungültiges Datum',
    'Organization Details': 'Organisationsdetails',
    'All Licenses': 'Alle Lizenzen',
    'All License Types': 'Alle Lizenztypen',
    'Select Branch': 'Zweig auswählen',
    'Unlink Licenses': 'Lizenzen trennen',
    'Unlink License': 'Lizenz trennen',
    'Licenses transferred with success!': 'Lizenzen erfolgreich übertragen!',
    'Error in transfer!': 'Fehler beim Übertragen!',
    'An unexpected error occurred!': 'Ein unerwarteter Fehler ist aufgetreten!',
    'Transfer licenses to:': 'Lizenzen übertragen an:',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'Beim Löschen dieses Benutzers aus dem Portal bleiben sie auf Ihrem Livox-Tablet verfügbar. Wenn Sie nicht möchten, dass die Daten dieses Benutzers erneut an das Portal gesendet werden, löschen Sie sie auch von Ihrem Tablet.',
    'The Livox User has been deleted!': 'Der Livox-Benutzer wurde gelöscht!',
    'Failed to remove Livox User!':
      'Livox-Benutzer konnte nicht entfernt werden!',
    'Delete Livox User': 'Livox-Benutzer löschen',
    'Are you sure you want to delete this livox user?':
      'Sind Sie sicher, dass Sie diesen Livox-Benutzer löschen möchten?',
    'Activate with QRCode': 'Mit QRCode aktivieren',
    'Enter a valid holder email': 'Geben Sie eine gültige Inhaber-E-Mail ein',
    'To activate this license, enter the email of an associated holder.':
      'Um diese Lizenz zu aktivieren, geben Sie die E-Mail eines zugehörigen Inhabers ein.',
    'Holder Email': 'Inhaber-E-Mail',
    'Invalid email or not associated with this license.':
      'Ungültige E-Mail oder nicht mit dieser Lizenz verbunden.',
    Validate: 'Validieren',
    'Activate with QRCode in your Livox app':
      'Aktivieren Sie mit QRCode in Ihrer Livox-App',
    Distributor: 'Vertrieb',
    'Distributor Admin': 'Vertriebsadministrator',
    'Distributor Support': 'Vertriebssupport',
    'Create Support Area': 'Supportbereich erstellen',
    'enter support area name...': 'Supportbereichsnamen eingeben...',
    'Support area created successfully!':
      'Supportbereich erfolgreich erstellt!',
    'Removing this support area will only unlink customers and users from this area.':
      'Das Entfernen dieses Supportbereichs wird nur Kunden und Benutzer von diesem Bereich trennen.',
    'Are you sure you want to delete this support area?':
      'Sind Sie sicher, dass Sie diesen Supportbereich löschen möchten?',
    'The support area has been deleted!': 'Der Supportbereich wurde gelöscht!',
    'Failed to remove support area!':
      'Supportbereich konnte nicht entfernt werden!',
    'Support Area Users': 'Benutzer des Supportbereichs',
    'Remove Users': 'Benutzer entfernen',
    'Remove users from support area': 'Benutzer aus Supportbereich entfernen',
    'Failed to remove users': 'Benutzer konnten nicht entfernt werden',
    'Select Users': 'Benutzer auswählen',
    '{{count}} users successfully removed':
      '{{count}} Benutzer erfolgreich entfernt',
    'Support Area Customers': 'Kunden des Supportbereichs',
    'Select Customers': 'Kunden auswählen',
    'Customers added successfully!': 'Kunden erfolgreich hinzugefügt!',
    'Remove Customers': 'Kunden entfernen',
    '{{count}} customers successfully removed':
      '{{count}} Kunden erfolgreich entfernt',
    'Failed to remove customers': 'Kunden konnten nicht entfernt werden',
    'Remove customers from support area': 'Kunden aus Supportbereich entfernen',
    Add: 'Hinzufügen',
    'Support Areas per page': 'Supportbereiche pro Seite',
    'Created at': 'Erstellt am',
    'Confirm delete': 'Löschen bestätigen',
    'Android Versions': 'Android-Versionen',
    'Create Android Version': 'Android-Version erstellen',
    'Edit Android Version': 'Android-Version bearbeiten',
    'New Android Version': 'Neue Android-Version',
    'Android version created successfully!':
      'Android-Version erfolgreich erstellt!',
    'Android version updated successfully!':
      'Android-Version erfolgreich aktualisiert!',
    'The android version has been deleted!':
      'Die Android-Version wurde gelöscht!',
    'Failed to remove android version!':
      'Fehler beim Löschen der Android-Version!',
    'Are you sure you want to delete this android version?':
      'Sind Sie sicher, dass Sie diese Android-Version löschen möchten?',
    'Android Versions per page': 'Android-Versionen pro Seite',
    Resellers: 'Wiederverkäufer',
    'Create Reseller': 'Wiederverkäufer erstellen',
    'Edit Reseller': 'Wiederverkäufer bearbeiten',
    'New Reseller': 'Neuer Wiederverkäufer',
    'enter reseller name...': 'Wiederverkäufername eingeben...',
    'Reseller created successfully!': 'Wiederverkäufer erfolgreich erstellt!',
    'Reseller updated successfully!':
      'Wiederverkäufer erfolgreich aktualisiert!',
    'The reseller has been deleted!': 'Der Wiederverkäufer wurde gelöscht!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      'Fehler beim Löschen des Wiederverkäufers. Stellen Sie sicher, dass keine Lizenzen damit verknüpft sind.',
    'Are you sure you want to delete this reseller?':
      'Sind Sie sicher, dass Sie diesen Wiederverkäufer löschen möchten?',
    'Resellers per page': 'Wiederverkäufer pro Seite',
    'Payment QR Code': 'Zahlungs-QR-Code',
    'Payment link for {{name}}': 'Zahlungslink für {{name}}',
    'Payment link': 'Zahlungslink',
    'User created successfully!': 'Benutzer erfolgreich erstellt!',
    Spanish: 'Spanisch',
    'Billing user does not exist': 'Abrechnungsbenutzer existiert nicht',
    French: 'Französisch',
    Italian: 'Italienisch',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      'Unsere Website wurde aktualisiert, um Ihre Erfahrung zu verbessern. Um eine ordnungsgemäße Funktion zu gewährleisten, empfehlen wir, den Cache Ihres Browsers zu leeren. Wenn Sie die Livox-App Version 5 verwenden, schließen Sie bitte die App und öffnen Sie sie erneut, um die ordnungsgemäße Verbindung zu Ihrem Konto sicherzustellen.',
    'Website Update': 'Website-Aktualisierung',
    'Reload page': 'Seite neu laden',
    "Don't show again": 'Nicht nochmal anzeigen',
    'enter email': 'E-Mail eingeben',
    'Customer created successfully!': 'Kunde erfolgreich erstellt!',
    'Enter a valid email address': 'Geben Sie eine gültige E-Mail-Adresse ein',
    'Only letters are allowed': 'Es sind nur Buchstaben erlaubt',
    'enter number of devices': 'Geräteanzahl eingeben',
    'enter text': 'Text eingeben',
    'enter install key...': 'Installationsschlüssel eingeben...',
    'enter device name...': 'Gerätename eingeben...',
    'enter device nickname...': 'Gerätespitzname eingeben...',
    'enter device MAC address...': 'Geräte-MAC-Adresse eingeben...',
    'Device MAC Address': 'Geräte-MAC-Adresse',
    'Licenses created successfully!': 'Lizenzen erfolgreich erstellt!',
    Payment: 'Zahlung',
    'Registration link generated successfully!':
      'Registrierungslink erfolgreich generiert!',
    'Failed to generate registration link.':
      'Fehler beim Generieren des Registrierungslinks.',
    'Copy Link': 'Link kopieren',
    'Link copied to clipboard!': 'Link in die Zwischenablage kopiert!',
    '{{diff}} year(s) ago': 'vor {{diff}} Jahr(en)',
    '{{diff}} month(s) ago': 'vor {{diff}} Monat(en)',
    '{{diff}} day(s) ago': 'vor {{diff}} Tag(en)',
    '{{diff}} hour(s) ago': 'vor {{diff}} Stunde(n)',
    '{{diff}} minute(s) ago': 'vor {{diff}} Minute(n)',
    'Holder registered successfully!': 'Inhaber erfolgreich registriert!',
    'Register Holder': 'Inhaber registrieren',
    'enter address': 'Adresse eingeben',
    'confirm your password': 'Bestätigen Sie Ihr Passwort',
    'Passwords must match': 'Passwörter müssen übereinstimmen',
    'Professional Type': 'Berufstyp',
    'Speech Therapist': 'Logopäde',
    'Occupational Therapist': 'Ergotherapeut',
    Physiotherapist: 'Physiotherapeut',
    Teacher: 'Lehrer',
    Pedagogue: 'Pädagoge',
    Psychopedagogue: 'Psychopädagoge',
    Other: 'Andere',
    'Error loading subscription details':
      'Fehler beim Laden der Abonnementdetails',
    Activation: 'Aktivierung',
    Cancellation: 'Stornierung',
    'Due Date': 'Fälligkeitsdatum',
    'Payment Link': 'Zahlungslink',
    Receipt: 'Rechnung',
    'View Receipt': 'Rechnung ansehen',
    'Invoice Date': 'Rechnungsdatum',
    Paid: 'Bezahlt',
    'Invoice Status': 'Rechnungsstatus',
    'Receipt Link': 'Rechnung ansehen',
    'Status updated successfully': 'Status erfolgreich aktualisiert',
    'Failed to update license status': 'Statusaktualisierung fehlgeschlagen',
    'Edit License': 'Lizenz bearbeiten',
    'Are you sure you want to delete this license?':
      'Sind Sie sicher, dass Sie diese Lizenz löschen möchten?',
    'Are you sure you want to delete license':
      'Sind Sie sicher, dass Sie die Lizenz löschen möchten',
    'This will delete all licenses with install key: {{installKey}}':
      'Dies löscht alle Lizenzen mit Installationsschlüssel: {{installKey}}',
    'Permanently delete the license(s)': 'Lizenz(en) dauerhaft löschen',
    'License deleted successfully!': 'Lizenz erfolgreich gelöscht!',
    'Failed to delete license!': 'Löschen der Lizenz fehlgeschlagen!',
    'License updated successfully!': 'Lizenz erfolgreich aktualisiert!',
    'Failed to update license!': 'Aktualisierung der Lizenz fehlgeschlagen!',
    'No changes to save': 'Keine Änderungen zum Speichern',
    'Are you sure you want to update all licenses?':
      'Sind Sie sicher, dass Sie alle Lizenzen aktualisieren möchten?',
    'This will update all licenses with install key':
      'Dies aktualisiert alle Lizenzen mit Installationsschlüssel',
    'Update install key to': 'Installationsschlüssel aktualisieren auf',
    'Update type to': 'Typ aktualisieren auf',
    'All licenses with this install key will be affected!':
      'Alle Lizenzen mit diesem Installationsschlüssel werden betroffen sein!',
    'Click here': 'Klicken Sie hier',
    Donation: 'Spende',
    Sale: 'Verkauf',
    Evaluation: 'Bewertung',
    Research: 'Forschung',
    'Old Version (BETA TEST)': 'Alte Version (BETA TEST)',
    Developer: 'Entwickler',
    Representative: 'Vertreter',
    'Resale Channel': 'Rückverkaufskanal',
    'Are you sure you want to unblock this customer?':
      'Sind Sie sicher, dass Sie diesen Kunden entsperren möchten?',
    'Are you sure you want to block this customer?':
      'Sind Sie sicher, dass Sie diesen Kunden sperren möchten?',
    Block: 'Blockieren',
    'Change Status': 'Status ändern',
    'Are you sure you want to change the status?':
      'Sind Sie sicher, dass Sie den Status ändern möchten?',
    Select: 'Auswählen',
    'Unit manager': 'Einheitsleiter',
    'type to search': 'zum Suchen eingeben',
    'Manager e-mail': 'Manager E-Mail',
    'Create user': 'Benutzer erstellen',
    'Cancel user creation': 'Benutzererstellung abbrechen',
    'Select existing user': 'Vorhandenen Benutzer auswählen',
    'enter password': 'Passwort eingeben',
    'confirm password': 'Passwort bestätigen',
    'Select a manager or create a new user':
      'Wählen Sie einen Manager oder erstellen Sie einen neuen Benutzer',
    'Email not found. Click Create user':
      'E-Mail nicht gefunden. Klicken Sie auf Benutzer erstellen',
    'This email already exists. Select an existing user':
      'Diese E-Mail existiert bereits. Wählen Sie einen vorhandenen Benutzer',
    'Customer email already registered.':
      'Die E-Mail-Adresse des Kunden ist bereits registriert.',
    'Email is required': 'E-Mail ist erforderlich',
    'Invalid value': 'Ungültiger Wert',
    'This field is required': 'Dieses Feld ist erforderlich',
    'Password is required': 'Passwort ist erforderlich',
    'Confirm Exit': 'Beenden bestätigen',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      'Sind Sie sicher, dass Sie beenden möchten? Alle nicht gespeicherten Änderungen gehen verloren.',
    Export: 'Exportieren',
    'Export Charts': 'Diagramme Exportieren',
    'Export Charts to PDF': 'Diagramme als PDF exportieren',
    'Export Data': 'Daten Exportieren',
    'Exporting...': 'Exportieren...',
    'No data to export': 'Keine Daten zum Exportieren',
    'No charts found to export': 'Keine Diagramme zum Exportieren gefunden',
    'File exported successfully': 'Datei erfolgreich exportiert',
    'Charts exported successfully': 'Diagramme erfolgreich exportiert',
    'Export successful!': 'Export erfolgreich!',
    'Export failed!': 'Export fehlgeschlagen!',
    'Error exporting file': 'Fehler beim Exportieren der Datei',
    'Error exporting charts': 'Fehler beim Exportieren der Diagramme',
    'Are you sure you want to delete this user?':
      'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
    'Are you sure you want to delete user':
      'Sind Sie sicher, dass Sie den Benutzer löschen möchten',
    'This action will:': 'Diese Aktion wird:',
    'Unlink all licenses from the user holder':
      'Alle Lizenzen vom Benutzerinhaber trennen',
    'Delete the associated holder (if exists)':
      'Den zugehörigen Inhaber löschen (falls vorhanden)',
    'Remove user from all groups': 'Benutzer aus allen Gruppen entfernen',
    'Delete all Livox Users linked to this user':
      'Alle mit diesem Benutzer verknüpften Livox-Benutzer löschen',
    'Permanently delete the user account':
      'Das Benutzerkonto dauerhaft löschen',
    'This action cannot be undone!':
      'Diese Aktion kann nicht rückgängig gemacht werden!',
    'User updated successfully!': 'Benutzer erfolgreich aktualisiert!',
    'User deleted successfully!': 'Benutzer erfolgreich gelöscht!',
    '{{count}} licenses unlinked.': '{{count}} Lizenzen getrennt.',
    'Holder deleted.': 'Inhaber gelöscht.',
    'Failed to delete user!': 'Fehler beim Löschen des Benutzers!',
    'Changing password for user': 'Passwort ändern für Benutzer',
    'enter new password...': 'neues Passwort eingeben...',
    'Update Password': 'Passwort Aktualisieren',
    'Password updated successfully!': 'Passwort erfolgreich aktualisiert!',
    'confirm your password...': 'Passwort bestätigen...',
    'Edit Portal User': 'Portal-Benutzer bearbeiten',
    'User Details': 'Benutzerdetails',
    'Personal Data': 'Persönliche Daten',
    'View Details': 'Details anzeigen',
    'View Holder Details': 'Inhaberdetails anzeigen',
    'View Boards': 'Boards anzeigen',
    'View Content Store': 'Inhaltsshop anzeigen',
    'Created boards': 'Erstellte Boards',
    Total: 'Gesamt',
    'Published boards': 'Veröffentlichte Boards',
    'No holder linked': 'Kein Inhaber verknüpft',
    'No customer linked': 'Kein Kunde verknüpft',
    'User Boards': 'Benutzer-Boards',
    'View boards created by this user':
      'Boards anzeigen, die von diesem Benutzer erstellt wurden',
    'Customer not found': 'Kunde nicht gefunden',
    'Loading boards': 'Boards laden',
    "This user hasn't created any boards yet":
      'Dieser Benutzer hat noch keine Boards erstellt',
    'Create Holder': 'Inhaber Erstellen',
    'Edit Holder': 'Inhaber Bearbeiten',
    'Holder created successfully!': 'Inhaber erfolgreich erstellt!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'Kein Benutzer für diese E-Mail gefunden. Füllen Sie die folgenden Felder aus, um einen neuen Inhaber-Benutzer zu erstellen.',
    'Holder updated successfully!': 'Inhaber erfolgreich aktualisiert!',
    'Holder deleted successfully!': 'Inhaber erfolgreich gelöscht!',
    'Are you sure you want to delete this holder?':
      'Sind Sie sicher, dass Sie diesen Inhaber löschen möchten?',
    'Are you sure you want to delete holder':
      'Sind Sie sicher, dass Sie den Inhaber löschen möchten',
    'Release all licenses from this holder':
      'Alle Lizenzen von diesem Inhaber freigeben',
    'Permanently delete the holder': 'Den Inhaber dauerhaft löschen',
    '{{count}} licenses released.': '{{count}} Lizenzen freigegeben.',
    'Failed to delete holder!': 'Fehler beim Löschen des Inhabers!',
    'User is required': 'Benutzer ist erforderlich',
    'Country is required': 'Land ist erforderlich',
    'Zipcode is required': 'Postleitzahl ist erforderlich',
    'Phone number is required': 'Telefonnummer ist erforderlich',
    'enter zipcode...': 'Postleitzahl eingeben...',
    'enter address...': 'Adresse eingeben...',
    'enter city...': 'Stadt eingeben...',
    'enter state...': 'Bundesland eingeben...',
    'enter phone number...': 'Telefonnummer eingeben...',
    'enter professional record...': 'Berufsregister eingeben...',
    'Professional Record': 'Berufsregister',
    'Holder Details': 'Inhaberdetails',
    'Professional Information': 'Berufliche Informationen',
    'No licenses linked': 'Keine Lizenzen verknüpft',
    'Livox User Details': 'Livox-Benutzerdetails',
    'Personal Information': 'Persönliche Informationen',
    'Health Information': 'Gesundheitsinformationen',
    'Contact Information': 'Kontaktinformationen',
    'Responsible Information': 'Verantwortliche Informationen',
    'Responsible 1 Name': 'Name des Verantwortlichen 1',
    'Responsible 1 Email': 'E-Mail des Verantwortlichen 1',
    'Responsible 1 Phone': 'Telefon des Verantwortlichen 1',
    'Responsible 2 Name': 'Name des Verantwortlichen 2',
    'Responsible 2 Email': 'E-Mail des Verantwortlichen 2',
    'Responsible 2 Phone': 'Telefon des Verantwortlichen 2',
    'Autonomy Level': 'Autonomieniveau',
    'Current Communication': 'Aktuelle Kommunikation',
    'Visual Impairment': 'Sehbehinderung',
    'Fine Motor Skills': 'Feinmotorik',
    'Repetitive Movements': 'Repetitive Bewegungen',
    'Hearing Impairment': 'Hörbehinderung',
    'No data available': 'Keine Daten verfügbar',
    'Edit Livox User': 'Livox-Benutzer bearbeiten',
    Unauthorized: 'Unbefugt',
    'Board settings': 'Board-Einstellungen',
    'Board name and cover': 'Board-Name und Titelbild',
    'Board name': 'Board-Name',
    'Board cover image': 'Titelbild des Boards',
    'Board cover': 'Board-Titelbild',
    'Click the image to change': 'Bild anklicken zum Ändern',
    'Error uploading image': 'Fehler beim Hochladen des Bildes',
    'Error saving title': 'Fehler beim Speichern des Namens',
    'Move cards': 'Karten verschieben',
    'Select cards': 'Karten auswählen',
    Redo: 'Wiederholen',
    Help: 'Hilfe',
    Layout: 'Layout',
    'Board background color': 'Hintergrundfarbe des Boards',
    'Card settings': 'Karteneinstellungen',
    'Fixed bar settings': 'Einstellungen der festen Leiste',
    'Lock board horizontal': 'Board horizontal sperren',
    'Auto navigation cards': 'Automatische Navigationskarten',
    back: 'zurück',
    Columns: 'Spalten',
    'Select background color': 'Hintergrundfarbe auswählen',
    'General card settings': 'Allgemeine Karteneinstellungen',
    'Show text only': 'Nur Text anzeigen',
    'Text position': 'Textposition',
    Bottom: 'Unten',
    Top: 'Oben',
    'Show cards with levels as folders':
      'Karten mit Ebenen als Ordner anzeigen',
    'High contrast cards': 'Karten mit hohem Kontrast',
    'Black and white cards': 'Schwarz-weiße Karten',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'IntelliBar aktivieren',
    'IntelliBar description':
      'Wenn aktiviert, zeigt Livox oben auf dem Bildschirm eine Leiste, in der der Nutzer Sätze erstellen kann. Diese Funktion erfordert den Download des Konversationskarten-Boards IntelliBar, falls noch nicht geschehen.',
    'IntelliBar screen size': 'IntelliBar-Bildschirmgröße',
    'Speak card when adding to IntelliBar':
      'Karte beim Hinzufügen zur IntelliBar vorlesen',
    Disabled: 'Deaktiviert',
    Enabled: 'Aktiviert',
    'Partially enabled': 'Teilweise aktiviert',
    intelibar_speak_disabled_desc:
      'Livox spricht nur, wenn die Sprechtaste der IntelliBar angetippt wird.',
    intelibar_speak_partial_desc:
      'Livox spricht die angetippte Karte, die in die IntelliBar eingefügt wird.',
    intelibar_speak_full_desc: 'Livox spricht jede angetippte Karte.',
    'Speak card before adding': 'Karte vor dem Hinzufügen vorlesen',
    'Speak card after adding': 'Karte nach dem Hinzufügen vorlesen',
    'Show only card text in IntelliBar':
      'Nur Kartentext in der IntelliBar anzeigen',
    'Enable fixed bar': 'Feste Leiste aktivieren',
    'Fixed bar scroll up': 'Feste Leiste nach oben scrollen',
    'Fixed bar scroll down': 'Feste Leiste nach unten scrollen',
    'Fixed bar scroll left': 'Feste Leiste nach links scrollen',
    'Fixed bar scroll right': 'Feste Leiste nach rechts scrollen',
    'Fixed bar limit reached': 'Limit der festen Leiste erreicht',
    Position: 'Position',
    Side: 'Seite',
    'Visible cards count': 'Anzahl sichtbarer Karten',
    'Show as folder': 'Als Ordner anzeigen',
    'Select card bar color': 'Farbe der Kartenleiste auswählen',
    'Create a Card': 'Karte erstellen',
    Image: 'Bild',
    'Text/Spoken text': 'Text / gesprochener Text',
    'Color Background': 'Hintergrundfarbe',
    'Add media': 'Medien hinzufügen',
    'Image Bank': 'Bilddatenbank',
    'Search image': 'Bild suchen',
    'Starts with': 'Beginnt mit',
    'Card title': 'Kartentitel',
    'Spoken Text': 'Gesprochener Text',
    'Letters; Numbers': 'Buchstaben; Zahlen',
    'Text/Spoken Text': 'Text / Gesprochener Text',
    card_title_description: 'Dieser Text wird auf der Karte angezeigt.',
    'Spoken text': 'Gesprochener Text',
    spoken_text_description:
      'Dieser Text wird vorgelesen. Sie können lange Texte schreiben.',
    'Text font': 'Schriftart',
    'Text color': 'Textfarbe',
    'Background Color': 'Hintergrundfarbe',
    'Background color card': 'Kartenhintergrundfarbe',
    'Card border color': 'Kartenrahmenfarbe',
    'Attach a media': 'Medium anhängen',
    'No media': 'Kein Medium',
    'Record an audio': 'Audio aufnehmen',
    'Pick an audio': 'Audio auswählen',
    'Pick a video': 'Video auswählen',
    'Cards Properties': 'Karteneigenschaften',
    'Show just text': 'Nur Text anzeigen',
    show_just_text_desc:
      'Wenn aktiviert, zeigt Livox keine Karten mit Bild mehr',
    'Large size images': 'Große Bilder',
    large_images_desc: 'Wenn aktiviert, erscheinen Karten größer',
    'Keep the card unchanged': 'Karte unverändert lassen',
    keep_unchanged_desc:
      'Diese Karte wird auf Boards mit Standardwerten nicht geändert',
    'Display card in folder format': 'Karte im Ordnerformat anzeigen',
    'Card Title': 'Kartentitel',
    'Upload Card': 'Karte hochladen',
    'Board layout': 'Board-Layout',
    'Maintain relative positioning': 'Relative Positionierung beibehalten',
    help_move:
      'Aktivieren, um Karten auf dem Board zu ziehen und neu zu ordnen.',
    help_select: 'Aktivieren, um mehrere Karten gleichzeitig auszuwählen.',
    help_yesno: 'Aktivieren, um Ja/Nein-Schaltflächen auf Karten hinzuzufügen.',
    help_undo_redo:
      'Änderungen an den Einstellungen rückgängig machen oder wiederholen.',
    help_play_mode:
      'Öffnet das Board im Vollbild zur echten Nutzung: durch Karten und Ordner navigieren, Sätze bilden und vorlesen lassen.',
    help_export_pdf:
      'Exportiert das aktuelle Board als PDF-Datei zum Drucken oder Teilen.',
    help_ia:
      'Künstliche Intelligenz nutzen, um Karten automatisch vorzuschlagen.',
    'Card actions': 'Kartenaktionen',
    Interests: 'Interessen',
    'Android ID': 'Android ID',
    'Advanced Filters': 'Erweiterte Filter',
    'Apply Filters': 'Filter Anwenden',
    'Clear All': 'Alles Löschen',
    Order: 'Sortieren',
    Ascending: 'Aufsteigend',
    Descending: 'Absteigend',
    From: 'Von',
    To: 'Bis',
    All: 'Alle',
    Information: 'Informationen',
    Location: 'Standort',
    Keys: 'Schlüssel',
    'Date of Birth': 'Geburtsdatum',
    'Activated Licenses': 'Aktivierte Lizenzen',
    'Inactivated Licenses': 'Deaktivierte Lizenzen',
    Options: 'Optionen',
    Hide: 'Ausblenden',
    Show: 'Anzeigen',
    'Enter sublevel': 'Unterebene betreten',
    'Create folder': 'Ordner erstellen',
    'Edit Card': 'Karte bearbeiten',
    'Add state': 'Zustand hinzufügen',
    'Cannot access cards with more than one state':
      'Karten mit mehr als einem Zustand können nicht geöffnet werden.',
    'Cards with sublevels cannot have multiple states':
      'Karten mit Unterebenen können keine mehreren Zustände haben.',
    Untitled: 'Ohne Titel',
    'No states yet. Add one below.':
      'Noch keine Zustände. Füge unten einen hinzu.',
    'Generate image': 'Bild erstellen',
    'Enter image prompt...': 'Bildbeschreibung eingeben...',
    'Image style': 'Bildstil',
    'Download image': 'Bild herunterladen',
    Contains: 'Enthält',
    'Type to search symbols': 'Tippen um Symbole zu suchen',
    'Save failed': 'Speichern fehlgeschlagen',
    'Choose file from computer': 'Datei vom Computer wählen',
    Upload: 'Hochladen',
    'Upload failed': 'Upload fehlgeschlagen',
    'Select from image bank': 'Aus der Bilddatenbank wählen',
    'Generate with AI': 'Mit KI erstellen',
    Generated: 'Erstellt',
    'Upload an image from your device': 'Bild vom Gerät hochladen',
    'Choose a symbol from the image bank':
      'Symbol aus der Bilddatenbank wählen',
    Selected: 'Ausgewählt',
    'Unsaved image selected': 'Nicht gespeichertes Bild ausgewählt',
    'Upload image from computer': 'Bild vom Computer hochladen',
    'Select an image before saving the card.':
      'Wählen Sie ein Bild aus, bevor Sie die Karte speichern.',
    'Book Settings': 'Buch-Einstellungen',
    'Text size': 'Textgröße',
    'Highlight spoken text': 'Gesprochenen Text hervorheben',
    Exit: 'Beenden',
    'Start over': 'Von vorne beginnen',
    'To enable Book Mode, add cards to the board':
      'Um den Buchmodus zu aktivieren, füge Karten zur Tafel hinzu',
    'Deactivate Book Mode to create sublevels':
      'Deaktiviere den Buchmodus, um Unterebenen zu erstellen',
    'Continue from page {{page}}': 'Ab Seite {{page}} fortsetzen',
    'Open at page {{page}}': 'Auf Seite {{page}} öffnen',
    'To enable Book Mode, add child cards':
      'Um den Buchmodus zu aktivieren, füge untergeordnete Karten hinzu',
    'This book has no pages': 'Dieses Buch hat keine Seiten',
  },
}
